import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { ModuleUtils } from "./ModuleUtils.js";
import {
  DEFAULT_INVENTORY_UOM,
  DEFAULT_WAREHOUSE,
  NEW_ENTRY,
} from "../ds/App_Constants.js";
import { BaseBean, NodeData } from "../ds/client_ds.js";
import {
  AllBinCriteriaBean,
  FabricStyleBean,
  FabricStyleInventoryAdjustmentBean,
  FabricStyleInventoryAdjustmentLineBean,
  FabricStyleInventoryAdjustmentNewLineBean,
  FabricStyleInventoryAdjustmentSearchCriteria,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  PageListBean,
  PurchaseOrderReceiptSearchCriteria,
  ReasonBean,
  RestEntityUnLockRequest,
  RestFabricStyleInventoryAdjustmentListRequest,
  RestFabricStyleInventoryListRequest,
  RestFabricStyleListBeanRequest,
  RestFabricStyleListRequest,
  RestInventoryAdjustmentListRequest,
  RestInventoryEntityRequest,
  RestInventoryRollListRequest,
  RestPageListBean,
  RestPurchaseOrderReceiptListRequest,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  RollsSearchCriteria,
  SkuBatchInventoryDataBean,
  SKUBatchInventorySearchCriteria,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MessageBoxComponent,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  focusNextElement,
  focusPreviousElement,
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { InventoryAdjustmentLookupHandler } from "../lookup/InventoryAdjustmentLookupHandler.js";
import { PurchaseOrderReceiptLookupHandler } from "../lookup/PurchaseOrderReceiptLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import CustomTable from "../gui_components/CustomTable.js";
class InventoryAdjustmentList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.cancelReasonDialogRef = React.createRef();
    this.fabricStyleColorCodeRef = React.createRef();
    this.fabricStyleCodeRef = React.createRef();
    this.Adjustmentlinedata = React.createRef();
    this.state = {
      pageTitle: "Inventory Adjustment Maintenanceve",
      inventory_adj_list: [],
      companyCode: "",
      pageList: new RestPageListBean(),
      isLoading: false,
      criteria: new FabricStyleInventoryAdjustmentSearchCriteria(),
      inventoryAdjustmentData: new FabricStyleInventoryAdjustmentBean(),
      inventoryAdjustmentLineData: new FabricStyleInventoryAdjustmentLineBean(),
      inventoryAdjustmentNewLineData:
        new FabricStyleInventoryAdjustmentNewLineBean(),
      currentPageNumber: 0,
      totalCount: 0,
      isListMode: false,
      isEntryMode: false,
      isShowSaveButton: false,
      isShowCancelButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      isShowPDFReportButton: false,
      isAdjustementEntryFormOpen: false,
      isInventoryAdjustmentListFormOpen: true,
      isInventoryAdjustmentAddOpen: false,
      error_list: [],
      companyConfig: new Array(),
      isLoading: false,
      inventoryAdjustmentReasons: [],
      reasonData: new ReasonBean(),
      warehouses: [],
      documentTypes: [],
      fabricStyle_List: [],
      currentFabricStyle: new FabricStyleBean(),
      currentFabricStyleSku: new FabricStyleSKUBean(),
      currentFabricStyleSkuList: new Array(),
      nodeList: [],
      selectedNodeKey: "headerView",
      isShowNodes: false,
      isLoadExcelButton: true,
      isLoadReceiptButton: false,
      isAddRollFabricButton: false,
      isLoadBinInventoryButton: false,
      rollCriteria: new RollsSearchCriteria(),
      binInventoryList: [],
      fabricRollCriteria: new SKUBatchInventorySearchCriteria(),
      fabricStyleRollList: [],
      receiptCriteria: new PurchaseOrderReceiptSearchCriteria(),
      receiptList: [],
      receiptLines: [],
      receiptRollLines: [],
      selectedFabricStyleRollList: [],
      selectedBinRollList: [],
      isResetModule: false,
      moduleForPopup: [],
      isShowPopup: false,
      simplePopupContent: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      inventoryAdjustmentLookupHandler: null,
      isShowModuleSearchContainer: false,
      moduleKeyCode: "NEW",
      isResetModule: false,
      moduleOrderStatus: "",
      disableFormFields: false,
      isShowColorLookup: false,
      disabled: false,
      isResetView: true,
      isFocus: false,
      invDatas: [],
      isShowQtyList: false,
      excelInventoryList: [],
      isShowExcelDataPopup: false,
      fileName: "",
      selectedExcelDataList: [],
      excelIncompleteInventoryList: [],
      isMaintenanceMode: true,
      isDisabledFields: false,
      isshowaddorupdatebutton: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      skuBatchInventories: [],
      inventoryData: new SkuBatchInventoryDataBean(),
      isShowOnHandQtyPopup: false,
      isShowReceiptPopup: false,
      isShowFabricPopup: false,
      isShowBinPopup: false,

      order: "asc",
      colorList: [],
      showAutoCompleteBinLocationList: [],
      binLocationPageListForAutoCompleteList: new Array(),
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: false,
      showAutoCompleteFabricColorList: false,
      purchaseReceiptPageListForAutoCompleteList: new Array(),
      showAutoCompletepurchaseReceiptList: false,
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: false,
      documentPageListForAutoCompleteList: new Array(),
      showAutoCompleteDocumentList: false,
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: false,
      AdjReasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteAdjReasonList: false,
      receiptCode: "",
      isShowCancelReasonPopup: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      sortField: "",
      is3PL: false,
      onHandQtyData: [],
      isReseted: false,
      isViewMode: false,
      isShowWarningMsgPopup: false,
      warningMessage: "",
      isSavedWithWarning: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    this.state.criteria = new FabricStyleInventoryAdjustmentSearchCriteria();
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new RestPageListBean();
    this.state.pageList.pageSize = 50;
    this.fetchAttriburteCache();
    this.getFabricStyleList();
    this.getReceiptList();
    // this.initLookupHandlers();
    this.loadBinLocations();
    //set readOnly components using view Modes && disable toolbars
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.editInventoryAdjustment(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
      // this.loadInventoryAdjustmentPage();
    }
  }
  initLookupHandlers = () => {
    let inventoryAdjustmentLookupHandler = new InventoryAdjustmentLookupHandler(
      this.companyCode,
      "InventoryAdjustment",
    );
    this.setState({
      inventoryAdjustmentLookupHandler: inventoryAdjustmentLookupHandler,
    });
  };
  fetchAttriburteCache = () => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let warehouses = attribute_cache.warehouses;
    let warehouses_temp = [];
    let warehouses_cache = [];
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        warehouses_temp.push(attr);
        warehouses_cache = ModuleUtils.isActiveAttribute(warehouses_temp);
      });
    }
    let inventoryAdjustmentReasons = attribute_cache.inventoryAdjustmentReasons;
    let inventoryAdjustmentReasons_temp = [];
    let inventoryAdjustmentReasons_cache = [];
    if (
      inventoryAdjustmentReasons != null ||
      inventoryAdjustmentReasons != undefined
    ) {
      inventoryAdjustmentReasons.map((attr) => {
        inventoryAdjustmentReasons_temp.push(attr);
        inventoryAdjustmentReasons_cache = ModuleUtils.isActiveAttribute(
          inventoryAdjustmentReasons_temp,
        );
      });
    }
    let documentTypes = attribute_cache.documentTypes;
    let documentTypes_cache = [];
    if (documentTypes != null || documentTypes != undefined) {
      documentTypes.map((attr) => {
        documentTypes_cache.push(attr);
      });
    }
    this.setState(
      {
        warehouses: warehouses_cache,
        inventoryAdjustmentReasons: inventoryAdjustmentReasons_cache,
        documentTypes: documentTypes_cache,
      },
      () => {
        this.initLookupHandlers();
      },
    );
  };
  loadInventoryAdjustmentPage = () => {
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    let requestInput = new RestFabricStyleInventoryAdjustmentListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    if (
      SecurityAccessManager.InventoryAdjustmentMaintenanceView_IsAccessible()
    ) {
      InventoryService.getFabricStyleInventoryAdjustmentPageList(
        requestInput,
        this.loadInventoryAdjustmentResponse,
        this.loadInventoryAdjustmentError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadInventoryAdjustmentResponse = (response) => {
    let pageList = this.state.pageList;

    let inventory_adj_list = [];
    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricStyleInventoryAdjustmentPageList)
    ) {
      inventory_adj_list =
        response.data.fabricStyleInventoryAdjustmentPageList
          .fabricStyleInventoryAdjustments;

      pageList.totalCount =
        response.data.fabricStyleInventoryAdjustmentPageList.totalCount;
      pageList.currentPage =
        response.data.fabricStyleInventoryAdjustmentPageList.currentPage;
    }
    this.setState({
      isLoading: false,
      inventory_adj_list: inventory_adj_list,
      pageList: pageList,
      isLoading: false,
    });
  };
  loadInventoryAdjustmentError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Erro : " + error);
  };
  getFabricStyleList = () => {
    let criteria = new FabricStyleSearchCriteria();
    criteria.companyCode = this.companyCode;
    let requestInput = new RestFabricStyleListRequest();
    requestInput.pageInput = new RestPageListBean();
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      FabricStyleService.getFabricStylePageList(
        requestInput,
        this.loadFabricStyleResponse,
        this.loadFabricStyleError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadFabricStyleResponse = (response) => {
    const fabricStyle_List = response.data.fabricStylePageList.fabricStyles;
    if (fabricStyle_List == null) {
      fabricStyle_List = new Array();
    }
    this.setState({ fabricStyle_List: fabricStyle_List });
  };
  loadFabricStyleError = (error) => {
    ShowError("Error:" + error);
  };
  getReceiptList = () => {
    let receiptCriteria = new PurchaseOrderReceiptSearchCriteria();
    receiptCriteria.companyCode = this.companyCode;
    let requestInput = new RestPurchaseOrderReceiptListRequest();
    requestInput.pageInput = new RestPageListBean();
    requestInput.searchCriteria = receiptCriteria;
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
        requestInput,
        this.loadPurchaseOrderReceiptResponse,
        this.loadPurchaseOrderReceiptError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseOrderReceiptResponse = (response) => {
    let receiptList =
      response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
    if (receiptList == null) {
      receiptList = new Array();
    }
    this.setState({ receiptList: receiptList });
  };
  loadPurchaseOrderReceiptError = (error) => {
    ShowError("Error" + error);
  };
  onChange = (e) => {
    let tempInventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let tempLineData = this.state.inventoryAdjustmentLineData;
    let tempNewLineData = this.state.inventoryAdjustmentNewLineData;
    tempInventoryAdjustmentData[e.target.name] = e.target.value;
    let locationData = null;
    if (e.target.name == "locationCode") {
      locationData = e.target.value;
      tempLineData.locationCode = locationData;
      tempNewLineData.locationCode = locationData;
    }
    this.setState({
      inventoryAdjustmentData: tempInventoryAdjustmentData,
      inventoryAdjustmentLineData: tempLineData,
      inventoryAdjustmentNewLineData: tempNewLineData,
    });
  };
  onLineChange = (e) => {
    let tempLineData = this.state.inventoryAdjustmentNewLineData;
    tempLineData[e.target.name] = e.target.value;
    this.setState({
      inventoryAdjustmentNewLineData: tempLineData,
    });
    if (e.target.name == "fabricStyleColorCode") {
      this.fabricStyleColorSelected(e.target.value);
    }
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.inventoryAdjustmentNewLineData;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.inventoryAdjustmentNewLineData;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleShortName = "";
      criteria.fabricStyleColorCode = "";
      criteria.widthCode = "";
      criteria.uomCode = "";
      criteria.onHandQuantity = "";
      criteria.rollSkuNumber = 0;
      criteria.rollSkuOnHandQuantity = 0;
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        inventoryAdjustmentNewLineData: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: new Array(),
        inventoryData: new SkuBatchInventoryDataBean(),
        invDatas: new Array(),
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
      //this.readSelectedFabricStyle(fabricStyleCode);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ inventoryAdjustmentNewLineData: tempCriteria });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.readSelectedFabricStyle(e.target.value);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL
        ? "Reading Item"
        : "Read FabricStyle",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  onFabricColorCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let fabricStyleColorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.inventoryAdjustmentNewLineData;
      criteria.fabricStyleColorCode = "";
      criteria.widthCode = "";
      criteria.uomCode = "";
      criteria.onHandQuantity = "";
      criteria.rollSkuNumber = 0;
      criteria.rollSkuOnHandQuantity = 0;
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        inventoryAdjustmentNewLineData: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        inventoryData: new SkuBatchInventoryDataBean(),
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      fabricStyleColorCode !== ""
    ) {
      this.readFabricColorBySearchString(e.target.value);
      // this.fabricStyleColorSelected(e.target.value);
    }
  };
  fabricColorEnterKeyEventHandler = (e) => {
    console.log("enter called");
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading OnHandQty...",
    });
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteFabricColorList) => {
    this.setState({
      showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
    });
  };
  rollSkuOnChange = (e) => {
    let inventoryAdjustmentLineData = this.state.inventoryAdjustmentLineData;
    inventoryAdjustmentLineData.companyCode = this.companyCode;
    inventoryAdjustmentLineData[e.target.name] = e.target.value;
    this.setState({
      inventoryAdjustmentLineData: inventoryAdjustmentLineData,
    });
  };
  rollSkuNumberOnChange = (e) => {
    let inventoryAdjustmentLineData = this.state.inventoryAdjustmentLineData;
    inventoryAdjustmentLineData.companyCode = this.companyCode;
    inventoryAdjustmentLineData[e.target.name] = e.target.value;
    this.setState({
      inventoryAdjustmentLineData: inventoryAdjustmentLineData,
    });
    this.setInventoryAdjustmentLineData(e.target.value);
  };
  setInventoryAdjustmentLineData = (rollSku) => {
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.rollSkuNumber = rollSku;
    criteria.locationCode = this.state.inventoryAdjustmentData.locationCode;

    let pageInput = new PageListBean();
    let input = new RestSkuBatchInventoryListRequest();
    input.searchCriteria = criteria;
    input.pageInput = pageInput;
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      InventoryService.getSkuBatchAllWareHouseInventoryPageList(
        input,
        this.SkuBatchAllWareHouseInventoryResponse,
        this.SkuBatchAllWareHouseInventoryError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  SkuBatchAllWareHouseInventoryResponse = (response) => {
    let skuBatchInventories = [];
    let skuInventoryData = null;
    if (response.data.skuBatchInventoryPageList != null) {
      if (response.data.skuBatchInventoryPageList.skuBatchInventories != null) {
        skuBatchInventories =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
        skuBatchInventories.map((ln) => {
          skuInventoryData = ln;
        });
        if (skuBatchInventories.length > 0) {
          this.setRollLineValues(skuInventoryData);
        }
      } else {
        let errMsg = "Enter Valid SKU";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  SkuBatchAllWareHouseInventoryError = (error) => {};
  setRollLineValues = (skuInventoryData) => {
    let inventoryAdjustmentLineData = this.state.inventoryAdjustmentLineData;
    if (skuInventoryData != null) {
      inventoryAdjustmentLineData.fabricStyleCode =
        skuInventoryData.fabricStyleCode;
      inventoryAdjustmentLineData.fabricStyleShortName =
        skuInventoryData.fabricStyleName;
      inventoryAdjustmentLineData.fabricStyleColorCode =
        skuInventoryData.fabricStyleColorCode;
      inventoryAdjustmentLineData.skuNumber = skuInventoryData.skuNumber;
      inventoryAdjustmentLineData.uomCode = skuInventoryData.uomCode;
      inventoryAdjustmentLineData.boxNumber = skuInventoryData.boxNumber;
      inventoryAdjustmentLineData.vendorBatchNumber =
        skuInventoryData.vendorBatchNumber;
      inventoryAdjustmentLineData.rollNumber = skuInventoryData.rollNumber;
      inventoryAdjustmentLineData.locationCode = skuInventoryData.locationCode;
      inventoryAdjustmentLineData.widthCode = skuInventoryData.widthCode;
      inventoryAdjustmentLineData.onHandQuantity =
        skuInventoryData.onHandQuantity;
      inventoryAdjustmentLineData.binLocation = skuInventoryData.aisleInfoText;
      inventoryAdjustmentLineData.isCloseOutInventory =
        skuInventoryData.closeOutInventory;
    }
    this.setState({
      inventoryAdjustmentLineData: inventoryAdjustmentLineData,
    });
  };

  setFabricStyleSkuDetails = (currentFabricStyleSku) => {
    let inventoryAdjustmentLineData = this.state.inventoryAdjustmentLineData;
    let tempCurrentFabricStyle = this.state.currentFabricStyle;
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    this.setState({ inventoryAdjustmentLineData: inventoryAdjustmentLineData });
  };

  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.currentFabricStyle;
    let adjLine = this.state.inventoryAdjustmentNewLineData;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == adjLine.fabricStyleCode &&
        sku.fabricStyleColorCode == colorCode
      )
        skuBean = sku;
    });
    adjLine.fabricStyleColorCode = colorCode;
    if (!isEmpty(skuBean)) {
      adjLine.skuNumber = skuBean.skuNumber;
      // adjLine.onHandQuantity = 0;
      // this.getOnHandQty(skuBean.fabricStyleCode, skuBean.fabricStyleColorCode);
    }
    this.getOnHandQty(adjLine.fabricStyleCode, adjLine.fabricStyleColorCode);
    this.state.inventoryAdjustmentNewLineData = adjLine;
    this.setState({ inventoryAdjustmentNewLineData: adjLine });
  };
  readSelectedFabricStyle = (fabricStyleCode) => {
    let requestInput = new RestReadRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.code = fabricStyleCode;
    requestInput.isLockRequired = false;
    requestInput.loadChildren = true;

    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      FabricStyleService.readFabricStyle(
        requestInput,
        this.readFabricStyleResponse,
        this.readFabricStyleError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readFabricStyleResponse = (response) => {
    let fabricStyleBean = response.data.fabricStyle;
    let currentFabricStyleSkuList = new Array();
    if (fabricStyleBean) {
      this.state.currentFabricStyle = fabricStyleBean;
      if (fabricStyleBean.fabricStyleSkus) {
        fabricStyleBean.fabricStyleSkus.map((sku) => {
          currentFabricStyleSkuList.push(sku);
        });
      }

      this.setState({
        currentFabricStyle: fabricStyleBean,
        currentFabricStyleSkuList: currentFabricStyleSkuList,
        // isShowProgressBarPopup: false,
        // progressLoadingText: "",
      });
      this.setFabricStyleDefaultValues(fabricStyleBean);
      if (this.state.selectedNodeKey == "headerView") {
        this.getQtyList(fabricStyleBean.code);
      }
    }
  };
  readFabricStyleError = (error) => {
    ShowError(
      this.state.is3PL
        ? "readItemPageError"
        : "readFabricStylePageError" + error,
    );
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  setFabricStyleDefaultValues = (tempCurrentFabricStyle) => {
    let inventoryAdjustmentNewLineData =
      this.state.inventoryAdjustmentNewLineData;
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;

    inventoryAdjustmentNewLineData.fabricStyleCode =
      tempCurrentFabricStyle.code;
    inventoryAdjustmentNewLineData.fabricStyleShortName =
      tempCurrentFabricStyle.description;
    inventoryAdjustmentNewLineData.fabricStyleColorCode = "";
    inventoryAdjustmentNewLineData.widthCode = tempCurrentFabricStyle.width;
    inventoryAdjustmentNewLineData.uomConversionRate = 1;
    inventoryAdjustmentNewLineData.uomCode = DEFAULT_INVENTORY_UOM;
    inventoryAdjustmentNewLineData.onHandQuantity = 0;
    if (
      tempCurrentFabricStyle.inventoryUomCode != null &&
      tempCurrentFabricStyle.inventoryUomCode != ""
    ) {
      inventoryAdjustmentNewLineData.uomCode =
        tempCurrentFabricStyle.inventoryUomCode;
    }
    inventoryAdjustmentNewLineData.locationCode =
      inventoryAdjustmentData.locationCode;
    let colors = tempCurrentFabricStyle.colors;

    if (!isEmpty(colors)) {
      if (colors.length == 1) {
        if (colors[0].isActive) {
          inventoryAdjustmentNewLineData.fabricStyleColorCode =
            colors[0].fabricStyleColorCode;
          this.fabricStyleColorSelected(
            inventoryAdjustmentNewLineData.fabricStyleColorCode,
          );

          this.setState({
            isShowColorLookup: false,
          });

          focusPreviousElement();
        } else {
          let finalColorList = [];
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color",
          );
          this.setState({
            isShowColorLookup: true,
            colorList: finalColorList,
            colorLookupHandler: colorLookupHandler,
          });
        }
      } else {
        let finalColorList = [];
        console.log("Colors:", colors);
        colors.map((ent) => {
          if (ent.isActive === true) {
            let colorBean = new BaseBean();
            colorBean.code = ent.fabricStyleColorCode;
            colorBean.description = ent.fabricStyleColorName;
            finalColorList.push(colorBean);
          }
        });
        this.setState({ colorLookupHandler: null });
        console.log("finalColorList:", finalColorList);
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color",
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            colorList: finalColorList,
          });
        }
        focusNextElement();
      }
    }
    this.setState({
      inventoryAdjustmentNewLineData: inventoryAdjustmentNewLineData,
      inventoryAdjustmentData: inventoryAdjustmentData,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  getOnHandQty = (fabricCode, colorCode) => {
    let adjLine = this.state.inventoryAdjustmentNewLineData;
    let input = new SKUBatchInventorySearchCriteria();
    input.companyCode = this.companyCode;
    input.fabricStyleCode = fabricCode;
    input.colorCode = colorCode;
    input.skuNumber = adjLine.skuNumber;
    input.locationCode = adjLine.locationCode;
    input.isExcludeNonWarehouseInventory = true;
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      InventoryService.getSKUBatchInventoriesForRollBasedForSalesOrderOnHandQuantity(
        input,
        this.readandSetOnHandQuantityResponse,
        this.readandSetOnHandQuantityError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readandSetOnHandQuantityResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.batchInventoryDataResult) &&
      !isEmpty(response.data.batchInventoryDataResult.batchInventoryDataBean)
    ) {
      let invData = new SkuBatchInventoryDataBean();
      invData = response.data.batchInventoryDataResult.batchInventoryDataBean;
      let inventoryDataDetails = [];
      inventoryDataDetails = invData.inventoryDataDetails;
      let adjLine = this.state.inventoryAdjustmentNewLineData;
      adjLine.onHandQuantity = invData.totalOnHandQuantity;
      this.setState({
        inventoryData: invData,
        inventoryAdjustmentNewLineData: adjLine,
        onHandQtyData: inventoryDataDetails,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    setTimeout(() => {
      focusNextElement();
    }, 100);
  };
  readandSetOnHandQuantityError = (error) => {
    ShowError("Error : " + error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  getQtyList = (fabricCode) => {
    let requestInput = new RestFabricStyleInventoryListRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.fabricStyleCode = fabricCode;
    requestInput.loadChildren = true;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "loading Inventory Data...",
    });
    FabricStyleService.readFabricStyleWithInventoryDetails(
      requestInput,
      this.getQtyListResponse,
      this.getQtyListError,
    );
  };
  getQtyListResponse = (response) => {
    if (
      response.data != null &&
      response.data.result != null &&
      !isEmptyArray(response.data.result.inventoryDatas)
    ) {
      let invDatas = response.data.result.inventoryDatas;
      this.state.invDatas = invDatas;
      this.setState({
        invDatas: invDatas,
        isShowQtyList: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    setTimeout(() => {
      focusNextElement();
    }, 100);
  };
  getQtyListError = (error) => {
    ShowError("getQtyListError :", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  addOrUpdateLineChange = (e) => {
    let inventoryAdjustmentNewLineData =
      this.state.inventoryAdjustmentNewLineData;
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let inventoryAdjustmentLinesList =
      this.state.inventoryAdjustmentData.adjustmentNewLines;
    let isValidLine = false;
    isValidLine = this.validateLine(inventoryAdjustmentNewLineData);
    if (isValidLine) {
      let isLineFound = false;
      inventoryAdjustmentLinesList.map((line, i) => {
        if (line.lineNumber == inventoryAdjustmentNewLineData.lineNumber) {
          inventoryAdjustmentLinesList[i] = inventoryAdjustmentNewLineData;
          isLineFound = true;
        }
      });
      if (!isLineFound)
        inventoryAdjustmentLinesList.push(inventoryAdjustmentNewLineData);
      inventoryAdjustmentData.adjustmentNewLines = inventoryAdjustmentLinesList;
      this.setState({
        inventoryAdjustmentData: inventoryAdjustmentData,
        inventoryAdjustmentNewLineData:
          new FabricStyleInventoryAdjustmentNewLineBean(),
      });
      this.clearLineValues();
    }
  };
  clearLineValues = () => {
    if (this.fabricStyleColorCodeRef.current != null) {
      this.fabricStyleColorCodeRef.current.clear();
    }
    if (this.fabricStyleCodeRef.current != null) {
      this.fabricStyleCodeRef.current.clear();
      this.fabricStyleCodeRef.current.focus();
    }
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let lineNumber = 0;
    let lines = inventoryAdjustmentData.adjustmentNewLines;
    lines.map((line) => {
      if (line.lineNumber > lineNumber) {
        lineNumber = line.lineNumber;
      }
    });
    lineNumber++;
    let inventoryAdjustmentNewLineData =
      new FabricStyleInventoryAdjustmentNewLineBean();
    inventoryAdjustmentNewLineData.adjustmentCode =
      inventoryAdjustmentData.code;
    inventoryAdjustmentNewLineData.lineNumber = lineNumber;
    inventoryAdjustmentNewLineData.companyCode = this.companyCode;
    inventoryAdjustmentNewLineData.locationCode =
      inventoryAdjustmentData.locationCode;
    inventoryAdjustmentNewLineData.onHandQuantity = 0;

    this.setState({
      inventoryAdjustmentData: inventoryAdjustmentData,
      inventoryAdjustmentNewLineData: inventoryAdjustmentNewLineData,
      isShowColorLookup: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      colorList: new Array(),
      inventoryData: new SkuBatchInventoryDataBean(),
      invDatas: new Array(),
    });
  };
  validateLine = (inventoryAdjustmentNewLineData) => {
    let isValidatelLine = false;
    let err_list = [];
    let errorMessage = "";
    if (inventoryAdjustmentNewLineData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(inventoryAdjustmentNewLineData.fabricStyleCode)) {
        let errMsg = "";
        if (!this.state.is3PL) {
          errMsg = "FabricCode is Required";
        } else {
          errMsg = "ItemCode is Required";
        }
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(inventoryAdjustmentNewLineData.fabricStyleColorCode)) {
        let errMsg = "ColorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(inventoryAdjustmentNewLineData.quantity)) {
        let errMsg = "AdjustQty is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(inventoryAdjustmentNewLineData.vendorBatchNumber)) {
        let errMsg = "VENDOR LOT is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (inventoryAdjustmentNewLineData.skuNumber <= 0) {
        let errMsg = "Invalid Sku !";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidatelLine = false;
      this.setState({ errorList: err_list });

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isShowPopupAlert: false,
      });
    } else {
      isValidatelLine = true;
      this.setState({ isShowAlert: false, isShowPopupAlert: false });
    }
    return isValidatelLine;
  };
  validateRollLine = (inventoryAdjustmentLineData) => {
    let isValidateRollLine = false;
    let err_list = [];
    let errorMessage = "";
    if (inventoryAdjustmentLineData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(inventoryAdjustmentLineData.rollSkuNumber)) {
        // let errMsg = "RollSkuNumber is Required";
        let errMsg = this.state.is3PL
          ? "Inventory# is Required"
          : "RollSKU# is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      } else if (isEmptyString(inventoryAdjustmentLineData.fabricStyleCode)) {
        let errMsg = "Invalid item";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidateRollLine = false;
      this.setState({ errorList: err_list });

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isShowPopupAlert: false,
      });
    } else {
      isValidateRollLine = true;
      this.setState({ isShowAlert: false, isShowPopupAlert: false });
    }
    return isValidateRollLine;
  };
  addOrUpdateRollLineChange = (e) => {
    let isValidLine = false;
    let inventoryAdjustmentLineData = this.state.inventoryAdjustmentLineData;
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let inventoryAdjustmentLinesList =
      this.state.inventoryAdjustmentData.adjustmentLines;
    isValidLine = this.validateRollLine(inventoryAdjustmentLineData);
    if (isValidLine) {
      let isLineFound = false;
      inventoryAdjustmentLinesList.map((line, i) => {
        if (line.lineNumber == inventoryAdjustmentLineData.lineNumber) {
          inventoryAdjustmentLinesList[i] = inventoryAdjustmentLineData;
          isLineFound = true;
        }
      });
      if (!isLineFound)
        inventoryAdjustmentLinesList.push(inventoryAdjustmentLineData);
      inventoryAdjustmentData.adjustmentLines = inventoryAdjustmentLinesList;
      this.setState({
        inventoryAdjustmentData: inventoryAdjustmentData,
        inventoryAdjustmentLineData:
          new FabricStyleInventoryAdjustmentLineBean(),
      });
      this.clearRollLineValues();
    }
  };
  clearRollLineValues = () => {
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let lineNumber = 0;
    let lines = inventoryAdjustmentData.adjustmentLines;
    lines.map((line) => {
      if (line.lineNumber > lineNumber) {
        lineNumber = line.lineNumber;
      }
    });
    lineNumber++;
    let inventoryAdjustmentLineData =
      new FabricStyleInventoryAdjustmentLineBean();
    inventoryAdjustmentLineData.adjustmentCode = inventoryAdjustmentData.code;
    inventoryAdjustmentLineData.lineNumber = lineNumber;
    inventoryAdjustmentLineData.companyCode = this.companyCode;
    inventoryAdjustmentLineData.locationCode =
      inventoryAdjustmentData.locationCode;
    inventoryAdjustmentLineData.onHandQuantity = 0;
    this.setState({
      inventoryAdjustmentData: inventoryAdjustmentData,
      inventoryAdjustmentLineData: inventoryAdjustmentLineData,
    });
  };

  filterInventoryAdjustment = () => {
    this.loadPage(1);
  };
  resetfilteredAdjustment = (criteria) => {
    criteria = new FabricStyleInventoryAdjustmentSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
    criteria.criteriakey = "";
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  searchOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria["adjustmentCodeStartsWith"] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadInventoryAdjustmentPage();
  };
  addNewEntry = () => {
    let inventoryAdjustmentData = new FabricStyleInventoryAdjustmentBean();
    inventoryAdjustmentData.companyCode = this.companyCode;
    inventoryAdjustmentData.code = "NEW";
    inventoryAdjustmentData.locationCode = DEFAULT_WAREHOUSE;
    let pageTitle = this.moduleCaption + " - NEW";
    if (!isEmptyString(this.state.moduleKeyCode)) {
      inventoryAdjustmentData.code = this.state.moduleKeyCode;
    } else inventoryAdjustmentData.code = NEW_ENTRY;
    let lineNumber = 0;
    let lines = inventoryAdjustmentData.adjustmentNewLines;
    lines.map((line) => {
      if (line.lineNumber > lineNumber) {
        lineNumber = line.lineNumber;
      }
    });
    lineNumber++;
    let inventoryAdjustmentNewLineData =
      new FabricStyleInventoryAdjustmentNewLineBean();
    inventoryAdjustmentNewLineData.adjustmentCode =
      inventoryAdjustmentData.code;
    inventoryAdjustmentNewLineData.lineNumber = lineNumber;
    inventoryAdjustmentNewLineData.companyCode = this.companyCode;
    inventoryAdjustmentNewLineData.locationCode =
      inventoryAdjustmentData.locationCode;
    inventoryAdjustmentNewLineData.onHandQuantity = 0;
    let rollLineNumber = 0;
    let rollLines = inventoryAdjustmentData.adjustmentLines;
    rollLines.map((line) => {
      if (line.lineNumber > rollLineNumber) {
        rollLineNumber = line.lineNumber;
      }
    });
    rollLineNumber++;
    let inventoryAdjustmentLineData =
      new FabricStyleInventoryAdjustmentLineBean();
    inventoryAdjustmentLineData.adjustmentCode = inventoryAdjustmentData.code;
    inventoryAdjustmentLineData.lineNumber = rollLineNumber;
    inventoryAdjustmentLineData.companyCode = this.companyCode;
    inventoryAdjustmentLineData.locationCode =
      inventoryAdjustmentData.locationCode;
    inventoryAdjustmentLineData.onHandQuantity = 0;
    this.setState({
      inventoryAdjustmentData: inventoryAdjustmentData,
      pageTitle: pageTitle,
      inventoryAdjustmentNewLineData: inventoryAdjustmentNewLineData,
      inventoryAdjustmentLineData: inventoryAdjustmentLineData,
      isLoading: false,
      isLoadReceiptButton: false,
      isDisabledFields: false,
    });
    this.state.selectedNodeKey = "headerView";
    this.state.isEntryMode = true;
    this.state.isListMode = false;
    this.state.inventoryAdjustmentData = inventoryAdjustmentData;
    this.state.inventoryAdjustmentNewLineData = inventoryAdjustmentNewLineData;
    if (this.state.moduleKeyCode != NEW_ENTRY) this.isLocked = true;
    this.openEntryForm();
  };
  saveInventoryAdjustment = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let adjustmentBean = this.state.inventoryAdjustmentData;
    if (
      SecurityAccessManager.InventoryAdjustmentMaintenanceCreate_IsAccessible()
    ) {
      InventoryService.createFabricStyleInventoryAdjustment(
        adjustmentBean,
        this.saveInventoryAdjustmentResponse,
        this.saveInventoryAdjustmentError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  saveInventoryAdjustmentResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleresponse(response.data);
    const adjustmentData = response.data.inventoryAdjustmentBean;
    if (adjustmentData != null) {
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        inventoryAdjustmentData: adjustmentData,
        pageTitle: pageTitle,
      });
      if (this.state.moduleKeyCode != NEW_ENTRY) {
        this.unlockInventoryAdjustment(adjustmentData.code);
      }
      this.editInventoryAdjustment(adjustmentData.code);
    }
  };
  saveInventoryAdjustmentError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("saveInventoryAdjustmentError" + error);
  };
  editInventoryAdjustment = (adjustmentCode) => {
    this.setState({
      isLoading: true,
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = adjustmentCode;
    let isLockRequired = NEW_ENTRY === adjustmentCode ? false : true;
    // if (isUpdateReloadflag) isLockRequired = false;
    readrestInput.isLockRequired = isLockRequired;
    this.setState({ isLoading: true });
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      InventoryService.initFabricStyleInventoryAdjustmentModule(
        readrestInput,
        this.readInventoryAdjustmentResponse,
        this.readInventoryAdjustmentError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readInventoryAdjustmentResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.inventoryAdjustmentResponseBean != null) {
      if (response.data.inventoryAdjustmentResponseBean.errors != null) {
        response.data.inventoryAdjustmentResponseBean.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    // if (
    //   errMsg != this.state.is3PL
    //     ? "Item Inventory Adjustment"
    //     : " FabricStyle Inventory Adjustment " +
    //       this.state.moduleKeyCode +
    //       " Not Read Sucessfully "
    // ) {
    //   this.showErrorMessage(response.data.inventoryAdjustmentResponseBean);
    // }
    // if (
    //   errMsg !=
    //   " FabricStyle Inventory Adjustment " +
    //     this.state.moduleKeyCode +
    //     " Not Read Sucessfully "
    // ) {
    if (!errMsg.includes("Not Read"))
      this.showErrorMessage(response.data.inventoryAdjustmentResponseBean);
    // }

    if (
      response.data != null &&
      response.data.inventoryAdjustmentResponseBean != null
    ) {
      let adjustmentBean =
        response.data.inventoryAdjustmentResponseBean.inventoryAdjustmentBean;
      if (adjustmentBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        let moduleKeyCode = adjustmentBean.code;
        this.state.inventoryAdjustmentData = adjustmentBean;
        if (
          adjustmentBean.adjustmentNewLines != null &&
          !isEmptyArray(adjustmentBean.adjustmentNewLines)
        ) {
          this.setState({ selectedNodeKey: "headerView", isShowQtyList: true });
        }
        if (
          adjustmentBean.adjustmentLines != null &&
          !isEmptyArray(adjustmentBean.adjustmentLines)
        ) {
          this.setState({
            selectedNodeKey: "rollSkuView",
            isShowQtyList: false,
          });
        }
        this.setState({
          inventoryAdjustmentData: adjustmentBean,
          pageTitle: pageTitle,
          moduleKeyCode: moduleKeyCode,
          isLoading: false,
          isDisabledFields: true,
        });
        this.openEntryForm();
      } else {
        this.addNewEntry();
      }
    }
  };
  readInventoryAdjustmentError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("readInventoryAdjustmentError:", error);
  };
  saveCancelInventoryAdjustment = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling ..",
    });
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let adjustmentRequest = new RestInventoryAdjustmentListRequest();
    adjustmentRequest.invBean = inventoryAdjustmentData;
    adjustmentRequest.reasonBean = this.state.reasonData;
    if (
      SecurityAccessManager.InventoryAdjustmentMaintenanceCancel_IsAccessible()
    ) {
      InventoryService.cancelFabricStyleInventoryAdjustment(
        adjustmentRequest,
        this.cancelInventoryAdjustmentResponse,
        this.cancelInventoryAdjustmentError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  cancelInventoryAdjustmentResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleresponse(response.data);
    let adjustmentBean = response.data.inventoryAdjustmentBean;
    let pageTitle = this.moduleCaption + " - EDIT";
    this.setState({
      inventoryAdjustmentData: adjustmentBean,
      pageTitle: pageTitle,
    });
    this.editInventoryAdjustment(adjustmentBean.code);
  };
  cancelInventoryAdjustmentError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("cancelInventoryAdjustmentError:" + error);
  };

  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.inventoryAdjustmentReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.inventoryAdjustmentReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.inventoryAdjustmentReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };

  cancelInventoryAdjustment = (e) => {
    if (e.detail == 1) this.openReasonCapture(1);
  };

  onCancelReasonContinue = () => {
    this.saveCancelInventoryAdjustment();
    this.closeReasonModelCallBack();
  };
  moduleCaption = "Inventory Adjustment Maintenance";
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let adjustData = this.state.inventoryAdjustmentData;
    let headerObject = this.getEmptyView();
    let rollSkuObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "General", headerObject);
    let rollSkuNode = new NodeData("rollSkuView", "RollSkuBased", headerObject);
    nodeList["headerView"] = headerNode;
    nodeList["rollSkuView"] = rollSkuNode;
    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    if (selectedNode == "headerView") {
      this.setHeaderViewButtons();
    } else if (selectedNode == "rollSkuView") {
      if (inventoryAdjustmentData.isFetched != true) {
        this.setLoadLinesButtons();
      }
    }
    this.setState({ selectedNodeKey: selectedNode });
  };
  setLoadLinesButtons = () => {
    this.setState({
      isLoadReceiptButton: true,
      isShowQtyList: false,
    });
  };
  setHeaderViewButtons = () => {
    this.setState({
      isLoadReceiptButton: false,
    });
  };
  clearNode = () => {
    let selectedNodeKey = this.state.selectedNodeKey;
    selectedNodeKey = "";
    this.setState({ selectedNodeKey: selectedNodeKey });
  };
  /* open InventoryAdjustment entry form*/
  openEntryForm = () => {
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    this.getNodeList();
    this.setState({
      isInventoryAdjustmentListFormOpen: false,
      isAdjustementEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowPDFReportButton: false,
      isShowCancelButton: false,
      isShowNodes: true,
      isResetView: false,
      isShowModuleSearchContainer: true,
      isLoadExcelButton: true,
      isshowaddorupdatebutton: true,
    });
    if (inventoryAdjustmentData) {
      if (inventoryAdjustmentData.isFetched === true) {
        this.setState({
          isShowSaveButton: false,
          isShowClearCriteriaButton: false,
          isShowClearErrorButton: false,
          isShowBackButton: true,
          isShowCancelButton: true,
          isResetView: false,
          isShowModuleSearchContainer: true,
          isLoadReceiptButton: false,
          isLoadExcelButton: false,
          isDisabledFields: true,
          isshowaddorupdatebutton: false,
        });
      }
    }
    if (inventoryAdjustmentData.status === "X") {
      this.setState({
        isShowCancelButton: false,
      });
    }
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        disabled: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
  };
  /* close InventoryAdjustment entry form*/
  closeEntryForm = () => {
    let pageTitle = this.moduleCaption;
    this.setState({
      isInventoryAdjustmentListFormOpen: true,
      isAdjustementEntryFormOpen: false,
      isShowNewButton: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowBackButton: false,
      isShowCancelButton: false,
      pageTitle: pageTitle,
      isShowColorLookup: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: "NEW",
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isshowaddorupdatebutton: true,
      inventoryAdjustmentData: new FabricStyleInventoryAdjustmentBean(),
      inventoryAdjustmentLineData: new FabricStyleInventoryAdjustmentLineBean(),
      inventoryAdjustmentNewLineData:
        new FabricStyleInventoryAdjustmentNewLineBean(),
      invDatas: new Array(),
    });
  };
  back = () => {
    this.closeEntryForm();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = new Array();
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    this.saveInventoryAdjustment();
  };
  readSelectedReceipt = (receiptCode) => {
    let readrestInput = new RestSkuBatchInventoryListRequest();
    let searchCriteria = new SKUBatchInventorySearchCriteria();
    let pageInput = new PageListBean();
    let inventoryAdjustmentdata = this.state.inventoryAdjustmentData;
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseReceitpNumber = receiptCode;
    searchCriteria.locationCode = inventoryAdjustmentdata.locationCode;
    readrestInput.searchCriteria = searchCriteria;
    readrestInput.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "reading.....",
    });
    console.log("load po readrestInput", readrestInput);
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      InventoryService.getSkuBatchInventoryPageList(
        readrestInput,
        this.readSelectedReceiptResponse,
        this.readSelectedReceiptError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readSelectedReceiptResponse = (response) => {
    console.log("load po response", response);
    if (!isEmpty(response.data) && !isEmptyArray(response.data.errors)) {
      this.closeRecieptLookup();
      this.clearPOReciept();
      this.showErrorMessage(response.data);
    }
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      if (response.data.skuBatchInventoryPageList.skuBatchInventories != null) {
        let rollLines =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
        let receiptRollLine = [];
        if (rollLines != null) {
          rollLines.map((line, i) => {
            receiptRollLine.push(line);
          });
          this.state.receiptRollLines = receiptRollLine;
        }
      }
    }
    setTimeout(() => {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }, 100);
  };
  readSelectedReceiptError = (error) => {
    ShowError("readSelectedReceiptError:" + error);
  };
  getAdjustmentDataMaxLineNumber() {
    let maxLineNumber = 0;
    let rolls = this.state.inventoryAdjustmentData.adjustmentLines;
    if (rolls.length > 0)
      rolls.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  loadReceiptRolls = () => {
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let receiptRollLines = this.state.receiptRollLines;
    if (!isEmptyArray(receiptRollLines)) {
      var lineNumber = this.getAdjustmentDataMaxLineNumber();
      for (let line of receiptRollLines) {
        let inventoryAdjustmentLineData =
          new FabricStyleInventoryAdjustmentLineBean();
        inventoryAdjustmentLineData.companyCode = this.companyCode;
        inventoryAdjustmentLineData.lineNumber = ++lineNumber;
        inventoryAdjustmentLineData.fabricStyleCode = line.fabricStyleCode;
        inventoryAdjustmentLineData.fabricStyleShortName = line.fabricStyleName;
        inventoryAdjustmentLineData.fabricStyleColorCode =
          line.fabricStyleColorCode;
        inventoryAdjustmentLineData.rollNumber = line.rollNumber;
        inventoryAdjustmentLineData.rollSkuNumber = line.rollSkuNumber;
        inventoryAdjustmentLineData.uomCode = line.uomCode;
        inventoryAdjustmentLineData.vendorBatchNumber = line.vendorBatchNumber;
        inventoryAdjustmentLineData.widthCode = line.widthCode;
        inventoryAdjustmentLineData.boxNumber = line.boxNumber;
        inventoryAdjustmentLineData.rollSkuOnHandQuantity =
          line.receivedQuantity;
        inventoryAdjustmentLineData.binLocation = line.aisleInfoText;
        inventoryAdjustmentLineData.skuNumber = line.skuNumber;
        inventoryAdjustmentLineData.locationCode = line.locationCode;
        inventoryAdjustmentData.adjustmentLines.push(
          inventoryAdjustmentLineData,
        );
      }
      console.log(
        "inventoryAdjustmentLineData:",
        this.state.inventoryAdjustmentNewLineData,
      );
      this.setState({ inventoryAdjustmentData: inventoryAdjustmentData });
    } else {
      let errMsg = "No Receipt Roll Lines";
      let errorList = [];
      errorList.push(errMsg);
      this.setState({
        alertMessage: errorList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  fabricRollCriteriaOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.fabricRollCriteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.fabricRollCriteria;
      criteria.fabricStyleCode = "";
      criteria.colorCode = "";
      criteria.fabricStyleShortName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        fabricRollCriteria: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        fabricColorPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;

    this.setState({ fabricRollCriteria: tempCriteria });
    this.readSelectedFabricStyleCode(fabricStyleCode);
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.readByFabricCodeResponseError,
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData = fabricStyleData.filter((item) => item.isActive);
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByFabricCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  readSelectedFabricStyleCode = (fabricStyleCode) => {
    let requestInput = new RestReadRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.code = fabricStyleCode;
    requestInput.isLockRequired = false;
    requestInput.loadChildren = true;
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      FabricStyleService.readFabricStyle(
        requestInput,
        this.readFabricStyleCodeResponse,
        this.readFabricStyleError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readFabricStyleCodeResponse = (response) => {
    let fabricStyleBean = response.data.fabricStyle;
    let currentFabricStyleSkuList = new Array();
    if (fabricStyleBean) {
      if (fabricStyleBean.fabricStyleSkus) {
        fabricStyleBean.fabricStyleSkus.map((sku) => {
          currentFabricStyleSkuList.push(sku);
        });
      }
      this.setFabricStyleCodeDefaultValues(fabricStyleBean);
    }
    this.setState({
      currentFabricStyle: fabricStyleBean,
      currentFabricStyleSkuList: currentFabricStyleSkuList,
    });
  };
  setFabricStyleCodeDefaultValues = (tempCurrentFabricStyle) => {
    let fabricRollCriteria = this.state.fabricRollCriteria;
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    fabricRollCriteria.fabricStyleCode = tempCurrentFabricStyle.code;
    fabricRollCriteria.fabricStyleShortName =
      tempCurrentFabricStyle.description;

    let colors = tempCurrentFabricStyle.colors;
    let finalColorList = [];
    colors.map((ent) => {
      if (ent.isActive === true) {
        let colorBean = new BaseBean();
        colorBean.code = ent.fabricStyleColorCode;
        colorBean.description = ent.fabricStyleColorName;
        finalColorList.push(colorBean);
      }
    });
    this.setState({ colorLookupHandler: null });
    if (finalColorList != null) {
      let colorLookupHandler = new GenericAttributeLookupHandler(
        finalColorList,
        "Color",
      );
      this.setState({
        colorLookupHandler: colorLookupHandler,
        isShowColorLookup: true,
        colorList: finalColorList,
      });
    }
    this.setState({
      fabricRollCriteria: fabricRollCriteria,
      inventoryAdjustmentData: inventoryAdjustmentData,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  fabricRollEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.readSelectedFabricStyleCode(e.target.value);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL
        ? "Reading Item"
        : "Reading FabricStyle",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteFabricColorList) => {
    this.setState({
      showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
    });
  };
  readFabricColorBySearchString(searchString) {
    let fabricStyle = this.state.currentFabricStyle;
    let criteria = this.state.inventoryAdjustmentNewLineData;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == criteria.fabricStyleCode &&
        sku.fabricStyleColorCode == searchString
      )
        skuBean = sku;
    });
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricRollColorOnChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let fabricRollCriteria = this.state.fabricRollCriteria;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.fabricRollCriteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        fabricRollCriteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColorBySearchString(e.target.value);
    }
    fabricRollCriteria[e.target.name] = e.target.value;
    this.setState({ fabricRollCriteria: fabricRollCriteria });
    this.fabricStyleColorCodeSelected(colorCode);
  };
  fabricStyleColorCodeSelected = (colorCode) => {
    let fabricStyle = this.state.currentFabricStyle;
    let fabricRollCriteria = this.state.fabricRollCriteria;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == fabricRollCriteria.fabricStyleCode &&
        sku.fabricStyleColorCode == colorCode
      )
        skuBean = sku;
    });
    fabricRollCriteria.colorCode = colorCode;
    this.setState({ fabricRollCriteria: fabricRollCriteria });
  };
  fabricRollColorEnterKeyEventHandler = (e) => {
    let colorCode = e.target.value;
    this.fabricStyleColorCodeSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  makeZero = () => {
    let selectedFabricStyleRollList = this.state.selectedFabricStyleRollList;

    selectedFabricStyleRollList.map((ln) => {
      if (ln.onHandQuantity > 0) {
        // ln.quantity = parseFloat(ln.quantity) - parseFloat(ln.onHandQuantity);
        ln.quantity = -parseFloat(ln.onHandQuantity);
      }
      this.setState({
        selectedFabricStyleRollList: selectedFabricStyleRollList,
      });
    });
  };
  binMakeZero = () => {
    this.warningToBinMakeZero();
  };
  warningToBinMakeZero = () => {
    let warningMessage = "";
    warningMessage = "Are you sure to Adjust Zero?";
    this.setState({
      warningMessage: warningMessage,
      isShowWarningMsgPopup: true,
    });
  };
  onYesButtonClick = (isSavedWithWarning) => {
    this.isSavedWithWarning(true);
  };
  onNoButtonClick = (isSavedWithWarning) => {
    this.isSavedWithWarning(false);
  };
  isSavedWithWarning = (isSavedWithWarning) => {
    this.state.isSavedWithWarning = isSavedWithWarning;
    this.setState({
      isSavedWithWarning: isSavedWithWarning,
    });
    if (isSavedWithWarning) {
      this.proceedBinMakeZero();
    }
    this.closeMessageModelCallBack();
  };
  closeMessageModelCallBack = () => {
    this.setState({ isShowWarningMsgPopup: false });
  };
  proceedBinMakeZero = () => {
    let selectedBinRollList = [...this.state.selectedBinRollList];
    selectedBinRollList.map((ln) => {
      if (ln.onHandQuantity > 0) {
        ln.quantity = -parseFloat(ln.onHandQuantity);
      }
      this.setState({
        selectedBinRollList: selectedBinRollList,
      });
    });
  };
  binLocClear = () => {
    let selectedBinRollList = this.state.selectedBinRollList;
    selectedBinRollList.map((ln) => {
      ln.aisleInfoText = "";
      this.setState({
        selectedBinRollList: selectedBinRollList,
      });
    });
  };
  fabricFetchRolls = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "fetching.....",
    });
    let searchCriteria = new SKUBatchInventorySearchCriteria();
    let criteria = this.state.fabricRollCriteria;
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCode = criteria.fabricStyleCode;
    searchCriteria.colorCode = criteria.colorCode;
    let pageInput = new RestPageListBean();
    // pageInput.pageSize = 20;
    // pageInput.currentPage = 1;
    let requestInput = new RestSkuBatchInventoryListRequest();
    requestInput.pageInput = pageInput;
    requestInput.searchCriteria = searchCriteria;
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      InventoryService.getSkuBatchAllWareHouseInventoryPageList(
        requestInput,
        this.fabricFetchRollResponse,
        this.fabricFetchRollError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  fabricFetchRollResponse = (response) => {
    let fabricStyleRollList = new Array();
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories,
        )
      ) {
        fabricStyleRollList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
      }
    }
    this.setState({
      fabricStyleRollList: fabricStyleRollList,
      selectedFabricStyleRollList: [],
    });
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  fabricFetchRollError = (error) => {
    ShowError("error :", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  rollCriteriaOnChange = (e) => {
    let rollCriteria = this.state.rollCriteria;
    rollCriteria.companyCode = this.companyCode;
    rollCriteria[e.target.name] = e.target.value;
    this.setState({ rollCriteria: rollCriteria });
  };
  // validateFetchLine = (searchCriteria) => {
  //   let isValidatelLine = false;
  //   let err_list = [];
  //   let errorMessage = "";
  //   if (isEmptyString(searchCriteria.binLocationCode)) {
  //     let errMsg = "Bin Start With is Required";
  //     errorMessage = errorMessage + errMsg;
  //     err_list.push(errMsg);
  //   }

  //   if (err_list.length > 0) {
  //     isValidatelLine = false;
  //     this.setState({ errorList: err_list });

  //     this.setState({
  //       alertMessage: err_list,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   } else {
  //     isValidatelLine = true;
  //     this.setState({ isShowAlert: false, isShowPopupAlert: false });
  //   }
  //   return isValidatelLine;
  // };
  fetchRolls = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "fetching.....",
    });
    let searchCriteria = new RollsSearchCriteria();
    let criteria = this.state.rollCriteria;
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.locationCode = criteria.locationCode;
    searchCriteria.binLocationCode = criteria.binLocationCode;
    // let isValidLine = false;
    // isValidLine = this.validateFetchLine(searchCriteria);
    // if (isValidLine) {
    if (!isEmptyString(searchCriteria.binLocationCode)) {
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      //a pageInput.currentPage = 1;
      let requestInput = new RestInventoryRollListRequest();
      requestInput.pageInput = pageInput;
      requestInput.searchCriteria = searchCriteria;
      if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
        InventoryService.getRollsForBinPageList(
          requestInput,
          this.fetchRollResponse,
          this.fetchRollError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      let errMsg = "Bin Start With is Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  fetchRollResponse = (response) => {
    this.showErrorMessage(response.data);
    let binInventoryList = new Array();

    if (
      response != null &&
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories,
        )
      ) {
        binInventoryList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
        console.log("binInventoryList :", binInventoryList);
      }
    }
    this.setState({
      binInventoryList: binInventoryList,
    });
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  fetchRollError = (error) => {
    ShowError("fetchRollError:" + error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  binSelectAll = (e) => {
    let list = this.state.binInventoryList;
    let isSelectedAll; //= e.target.value == true;
    list.map((line, i) => {
      line.isActive = true;
    });
    this.setState({ selectedBinRollList: list });
  };
  binUnSelectAll = (e) => {
    let list = this.state.binInventoryList;
    let isSelectedAll; //= e.target.value == true;
    list.map((line, i) => {
      line.isActive = false;
    });
    this.setState({ selectedBinRollList: [] });
  };
  fabricSelectAll = (e) => {
    let list = this.state.fabricStyleRollList;
    let isSelectedAll; //= e.target.value == true;
    list.map((line, i) => {
      line.isActive = true;
    });
    this.setState({ selectedFabricStyleRollList: list });
  };
  fabricUnSelectAll = (e) => {
    let list = this.state.fabricStyleRollList;
    let isSelectedAll; //= e.target.value == true;
    list.map((line, i) => {
      line.isActive = false;
    });
    this.setState({ selectedFabricStyleRollList: [] });
  };
  selectLineCheck = (e, rowData) => {
    rowData.isActive = e.target.value;
    if (rowData.isActive === true) {
      let selectedLine = this.state.selectedBinRollList;
      selectedLine.push(rowData);
      this.setState({ selectedBinRollList: selectedLine });
    } else {
      let selectedBinRollList = this.state.selectedBinRollList;
      let rollList = [];
      for (let roll of selectedBinRollList) {
        if (roll.isActive != rowData.isActive) {
          rollList.push(roll);
          this.setState({ selectedBinRollList: rollList });
        }
      }
    }
  };
  binAddLine = () => {
    let selectedBinRollList = this.state.selectedBinRollList;
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let isLineFound = false;

    if (!isEmptyArray(selectedBinRollList)) {
      let rollList = [];
      let adjLineData = new FabricStyleInventoryAdjustmentLineBean();
      var lineNumber = this.getAdjustmentDataMaxLineNumber();
      for (let list of selectedBinRollList) {
        let inventoryAdjustmentLineData =
          new FabricStyleInventoryAdjustmentLineBean();
        inventoryAdjustmentLineData.companyCode = this.companyCode;
        inventoryAdjustmentLineData.lineNumber = ++lineNumber;
        inventoryAdjustmentLineData.fabricStyleCode = list.fabricStyleCode;
        inventoryAdjustmentLineData.fabricStyleShortName = list.fabricStyleName;
        inventoryAdjustmentLineData.fabricStyleColorCode =
          list.fabricStyleColorCode;
        inventoryAdjustmentLineData.rollNumber = list.rollNumber;
        inventoryAdjustmentLineData.rollSkuNumber = list.rollSkuNumber;
        inventoryAdjustmentLineData.uomCode = list.uomCode;
        inventoryAdjustmentLineData.vendorBatchNumber = list.vendorBatchNumber;
        inventoryAdjustmentLineData.widthCode = list.widthCode;
        inventoryAdjustmentLineData.boxNumber = list.boxNumber;
        inventoryAdjustmentLineData.binLocation = list.aisleInfoText;
        inventoryAdjustmentLineData.skuNumber = list.skuNumber;
        inventoryAdjustmentLineData.onHandQuantity = list.onHandQuantity;
        inventoryAdjustmentLineData.locationCode = list.locationCode;
        adjLineData = inventoryAdjustmentLineData;
        inventoryAdjustmentData.adjustmentLines.push(
          inventoryAdjustmentLineData,
        );
      }
      this.setState({
        inventoryAdjustmentData: inventoryAdjustmentData,
        binInventoryList: [],
        rollCriteria: new RollsSearchCriteria(),
        selectedBinRollList: [],
      });
    }
  };
  fabricLineCheck = (e, rowData) => {
    rowData.isActive = e.target.value;
    let selectedLine = this.state.selectedFabricStyleRollList;
    if (rowData.isActive === true) {
      selectedLine.push(rowData);
      this.setState({ selectedFabricStyleRollList: selectedLine });
    } else {
      let selectedFabricStyleRollList = this.state.selectedFabricStyleRollList;
      let rollList = [];
      for (let roll of selectedFabricStyleRollList) {
        if (roll.isActive != rowData.isActive) {
          rollList.push(roll);
          this.setState({ selectedFabricStyleRollList: rollList });
        }
      }
    }
  };
  fabricRollAddLine = () => {
    let selectedFabricStyleRollList = this.state.selectedFabricStyleRollList;
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    if (!isEmptyArray(selectedFabricStyleRollList)) {
      // let rollData = new FabricStyleInventoryAdjustmentLineBean();
      var lineNumber = this.getAdjustmentDataMaxLineNumber();
      for (let list of selectedFabricStyleRollList) {
        let inventoryAdjustmentLineData =
          new FabricStyleInventoryAdjustmentLineBean();
        inventoryAdjustmentLineData.companyCode = this.companyCode;
        inventoryAdjustmentLineData.adjustmentCode =
          inventoryAdjustmentData.code;
        inventoryAdjustmentLineData.lineNumber = ++lineNumber;
        inventoryAdjustmentLineData.fabricStyleCode = list.fabricStyleCode;
        inventoryAdjustmentLineData.fabricStyleShortName = list.fabricStyleName;
        inventoryAdjustmentLineData.fabricStyleColorCode =
          list.fabricStyleColorCode;
        inventoryAdjustmentLineData.rollNumber = list.rollNumber;
        inventoryAdjustmentLineData.rollSkuNumber = list.rollSkuNumber;
        inventoryAdjustmentLineData.uomCode = list.uomCode;
        inventoryAdjustmentLineData.vendorBatchNumber = list.vendorBatchNumber;
        inventoryAdjustmentLineData.widthCode = list.widthCode;
        inventoryAdjustmentLineData.boxNumber = list.boxNumber;
        inventoryAdjustmentLineData.binLocation = list.aisleInfoText;
        inventoryAdjustmentLineData.skuNumber = list.skuNumber;
        inventoryAdjustmentLineData.onHandQuantity = list.onHandQuantity;
        inventoryAdjustmentLineData.locationCode = list.locationCode;
        if (list.quantity != undefined && list.quantity != null) {
          inventoryAdjustmentLineData.quantity = list.quantity;
        }
        // rollData = inventoryAdjustmentLineData;
        inventoryAdjustmentData.adjustmentLines.push(
          inventoryAdjustmentLineData,
        );
      }
      this.setState({
        inventoryAdjustmentData: inventoryAdjustmentData,
        fabricStyleRollList: [],
        fabricRollCriteria: new SKUBatchInventorySearchCriteria(),
        selectedFabricStyleRollList: [],
      });
    }
  };
  getLineDetails = (rowData) => {
    let lineDetail = { ...rowData };
    this.setState({ inventoryAdjustmentNewLineData: lineDetail });
  };
  getRollSkuLineDetails = (rowData) => {
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let lineDetail = { ...rowData };
    if (lineDetail.locationCode === undefined)
      lineDetail.locationCode = inventoryAdjustmentData.locationCode;
    this.setState({ inventoryAdjustmentLineData: lineDetail });
  };
  reArrangeInventoryAdjustmentLineNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  deleteAdjustmentLines = (rowData) => {
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let lineData = inventoryAdjustmentData.adjustmentLines;
    if (rowData.isFetched == false) {
      var index = lineData.indexOf(rowData);
      if (index > -1) {
        lineData.splice(index, 1);
      }
    } else {
      let errMsg = "Already Added Lines Cannot be Removed";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.reArrangeInventoryAdjustmentLineNumbers(lineData);
    this.setState({ inventoryAdjustmentData: inventoryAdjustmentData });
  };
  deleteAdjustmentNewLines = (rowData) => {
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let lineData = inventoryAdjustmentData.adjustmentNewLines;
    if (rowData.isFetched == false) {
      var index = lineData.indexOf(rowData);
      if (index > -1) {
        lineData.splice(index, 1);
      }
    } else {
      let errMsg = "Already Added Lines Cannot be Removed";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.reArrangeInventoryAdjustmentLineNumbers(lineData);
    this.setState({ inventoryAdjustmentData: inventoryAdjustmentData });
  };
  unlockInventoryAdjustment = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      InventoryService.unLockFabricStyleInventoryAdjustmentCode(
        request,
        this.unlockInventoryAdjustmentResponse,
        this.unlockInventoryAdjustmentError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockInventoryAdjustmentResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        this.isLocked = false;
      } else {
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockInventoryAdjustmentError = (error) => {
    ShowError("Error : ", error);
  };
  getModuleListView = () => {
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    if (inventoryAdjustmentData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadInventoryAdjustmentPage();
    } else {
      if (!this.state.isViewMode && this.isLocked)
        this.unlockInventoryAdjustment(inventoryAdjustmentData.code);

      this.closeEntryForm();
      this.loadInventoryAdjustmentPage();
    }
  };
  resetView = () => {
    let inventoryAdjustment_Data = this.state.inventoryAdjustmentData;
    this.state.isReseted = true;

    if (!this.state.isViewMode && this.isLocked)
      this.unlockInventoryAdjustment(inventoryAdjustment_Data.code);

    let inventoryAdjustmentData = new FabricStyleInventoryAdjustmentBean();
    this.setState({
      inventoryAdjustmentData: inventoryAdjustmentData,
      isResetModule: true,
      moduleKeyCode: "NEW",
      isShowColorLookup: false,
      disabled: false,
      isDisabledFields: false,
      isshowaddorupdatebutton: true,
      invDatas: [],
      showAutoCompleteBinLocationList: [],
      binLocationPageListForAutoCompleteList: new Array(),
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: false,
      showAutoCompleteFabricColorList: false,
      purchaseReceiptPageListForAutoCompleteList: new Array(),
      showAutoCompletepurchaseReceiptList: false,
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: false,
      binLocationPageListForAutoCompleteList: new Array(),
      showAutoCompleteBinLocationList: false,
      documentPageListForAutoCompleteList: new Array(),
      showAutoCompleteDocumentList: false,
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: false,
      AdjReasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteAdjReasonList: false,
      onHandQtyData: [],
      invDatas: new Array(),
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.state.isViewMode = false;
    this.code = NEW_ENTRY;
    this.addNewEntry();
    this.hideAlertCallBack();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  moduleExit = () => {
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    if (inventoryAdjustmentData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (!this.state.isViewMode && this.isLocked)
        this.unlockInventoryAdjustment(inventoryAdjustmentData.code);

      this.props.onModuleExit();
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  selectButtonClick = (e) => {
    this.editInventoryAdjustment(this.state.moduleKeyCode);
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  uploadExcelFile = (e) => {
    let file = e.target.files[0];
    let fileName = file.name;
    let fileData = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", fileData);

    this.setState({ fileName: fileName });
    console.log("filename excel:", fileName);
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      InventoryService.inventoryExcelUpload(
        formData,
        this.uploadInventoryExcelResponse,
        this.uploadInventoryExcelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadInventoryExcelResponse = (response) => {
    console.log("excel response :", response);
    if (response.data != null) {
      if (response.data.success == true) {
        this.getExcelData();
      }
    }
  };
  uploadInventoryExcelError = (error) => {};
  getExcelData = () => {
    let request = new RestInventoryEntityRequest();
    request.companyCode = this.companyCode;
    request.code = this.state.inventoryAdjustmentData.code;
    request.EntityCode = this.state.fileName;
    console.log("excel request :", request);
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      InventoryService.getInventoryInputFromExcel(
        request,
        this.getInventoryExcelResponse,
        this.getInventoryExcelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getInventoryExcelResponse = (response) => {
    console.log("excel response getinventory :", response);
    this.showErrorMessage(response.data);
    if (response.data != null) {
      if (response.data.einput != null) {
        let excelInventoryList = response.data.einput.lines;
        for (let lines of excelInventoryList) {
          if (lines.rollSkuNumber > 0) {
            this.setState({
              excelInventoryList: excelInventoryList,
              isShowExcelDataPopup: true,
            });
          } else {
            this.setState({
              excelIncompleteInventoryList: lines,
              isShowExcelDataPopup: true,
            });
          }
        }
      }
    }
  };
  getInventoryExcelError = (error) => {
    ShowError("error :", error);
  };
  selectAllExcelLine = (e) => {
    if (e.detail <= 1) {
      let list = this.state.excelInventoryList;
      list.map((line, i) => {
        line.isActive = true;
      });
      this.setState({ selectedExcelDataList: list });
    }
  };
  unSelectAllExcelLine = (e) => {
    if (e.detail <= 1) {
      let list = this.state.excelInventoryList;
      list.map((line, i) => {
        line.isActive = false;
      });
      this.state.selectedExcelDataList = [];
      this.setState({ selectedExcelDataList: [] });
    }
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let inventory_adj_list = this.state.inventory_adj_list;
    if (sortField && !isEmptyArray(inventory_adj_list)) {
      const sorted = [...inventory_adj_list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inventory_adj_list: sorted });
    }
  };
  excelDataLineCheck = (e, rowData) => {
    rowData.isActive = e.target.value;
    let selectedLine = this.state.selectedExcelDataList;
    if (rowData.isActive === true) {
      selectedLine.push(rowData);
      this.setState({ selectedExcelDataList: selectedLine });
    } else {
      let selectedExcelDataList = this.state.selectedExcelDataList;
      let list = [];
      for (let data of selectedExcelDataList) {
        if (data.isActive != rowData.isActive) {
          list.push(data);
          this.setState({ selectedExcelDataList: list });
          this.state.selectedExcelDataList = list;
        }
      }
    }
  };
  excelListColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setInputDetails(
          false,
          false,
          true,
          null,
          this.excelDataLineCheck,
          null,
        ),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "ItemName" : "FabricStyleName",
          "fabricStyleName",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot#", "lotNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Box#", "boxNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Seq#" : "Roll#", "rollNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM#", "uom", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "binLocation", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty#", "quantity", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );

    return columns;
  };
  excelListColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null,
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.excelDataLineCheck,
        ),
    );
    if (this.state.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Item", "fabricStyleCode"),
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Fabric#", "fabricStyleCode"),
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails("Color", "colorCode"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Lot#", "lotNumber"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Box#", "boxNumber"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Seq#" : "Roll#",
        "rollNumber",
      ),
    );
    columnList.push(new DataGridColumnDefinition().setDetails("UOM#", "uom"));
    columnList.push(
      new DataGridColumnDefinition().setDetails("Location", "binLocation"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("OnHandQty#", "quantity", 1),
    );
    return columnList;
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowExcelDataPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isShowReceiptPopup: isShowPopup,
      isShowFabricPopup: isShowPopup,
      isShowBinPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isShowOnHandQtyPopup: isShowPopup,
      isShowColorLookup: isShowPopup,
    });
  };
  addExcelDataLine = (e) => {
    if (e.detail == 1) {
      let selectedExcelDataList = this.state.selectedExcelDataList;
      let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
      if (selectedExcelDataList != null) {
        var lineNumber = this.getAdjustmentDataMaxLineNumber();
        for (let list of selectedExcelDataList) {
          let inventoryAdjustmentLineData =
            new FabricStyleInventoryAdjustmentLineBean();
          inventoryAdjustmentLineData.companyCode = this.companyCode;
          inventoryAdjustmentLineData.adjustmentCode =
            inventoryAdjustmentData.code;
          inventoryAdjustmentLineData.lineNumber = ++lineNumber;
          inventoryAdjustmentLineData.fabricStyleCode = list.fabricStyleCode;
          inventoryAdjustmentLineData.fabricStyleShortName =
            list.fabricStyleName;
          inventoryAdjustmentLineData.fabricStyleColorCode = list.colorCode;
          inventoryAdjustmentLineData.rollNumber = list.rollNumber;
          inventoryAdjustmentLineData.rollSkuNumber = list.rollSkuNumber;
          inventoryAdjustmentLineData.uomCode = list.uom;
          inventoryAdjustmentLineData.vendorBatchNumber = list.lotNumber;
          inventoryAdjustmentLineData.widthCode = list.widthCode;
          inventoryAdjustmentLineData.boxNumber = list.boxNumber;
          inventoryAdjustmentLineData.binLocation = list.binLocation;
          inventoryAdjustmentLineData.skuNumber = list.skuNumber;
          inventoryAdjustmentLineData.onHandQuantity = list.quantity;
          inventoryAdjustmentLineData.locationCode = list.warehouse;
          inventoryAdjustmentData.adjustmentLines.push(
            inventoryAdjustmentLineData,
          );
        }
      }
      this.setState({
        inventoryAdjustmentData: inventoryAdjustmentData,
        excelInventoryList: [],
        selectedExcelDataList: [],
        isShowExcelDataPopup: false,
      });
    }
  };
  clearPOReciept = () => {
    this.setState({
      receiptCriteria: new PurchaseOrderReceiptSearchCriteria(),
      purchaseReceiptPageListForAutoCompleteList: new Array(),
      showAutoCompletepurchaseReceiptList: false,
    });
  };
  onAdjReasonChange = (e) => {
    let adjustmentReason = e.target.value;
    this.state.showAutoCompleteAdjReasonList = true;
    let tempCriteria = this.state.inventoryAdjustmentData;
    let showAutoCompleteList = this.state.showAutoCompleteAdjReasonList;
    if (isEmpty(adjustmentReason)) {
      this.state.showAutoCompleteAdjReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteAdjReasonList;
      let criteria = this.state.inventoryAdjustmentData;
      criteria.adjustmentReason = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteAdjReasonList: showAutoCompleteList,
        inventoryAdjustmentData: criteria,
        AdjReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "adjustmentReason" &&
      showAutoCompleteList === true &&
      adjustmentReason !== ""
    ) {
      this.readAdjReasonBySearchString(e.target.value);
    }
    tempCriteria["adjustmentReason"] = e.target.value;
    this.readAdjReason(adjustmentReason);

    this.setState({ inventoryAdjustmentData: tempCriteria });
  };
  readAdjReason = (adjustmentReason) => {
    let tempCriteria = this.state.inventoryAdjustmentData;
    tempCriteria["adjustmentReason"] = adjustmentReason;
    let documentType_List = this.state.inventoryAdjustmentReasons;
    documentType_List.map((adjustmentReason) => {
      if (adjustmentReason.code == adjustmentReason) {
        tempCriteria["adjustmentReason"] = adjustmentReason.code;
        this.state.showAutoCompleteAdjReasonList = false;
        let showAutoCompleteAdjReasonList =
          this.state.showAutoCompleteAdjReasonList;
        this.setState({
          showAutoCompleteAdjReasonList: showAutoCompleteAdjReasonList,
        });
      }
    });

    this.setState({ inventoryAdjustmentData: tempCriteria });
  };
  readAdjReasonBySearchString(searchString) {
    let AdjReasonData = this.state.inventoryAdjustmentReasons;
    let simpleAutoCompleteList = new Array();
    if (AdjReasonData.length > 0 && AdjReasonData != null) {
      AdjReasonData.map((adjustmentReasons) => {
        let simpleItemBean = {
          code: adjustmentReasons.code,
          description: adjustmentReasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteAdjReasonLists) =>
        simpleAutoCompleteAdjReasonLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      AdjReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  AdjReasonEnterKeyEventHandler = (e) => {
    let adjustmentReason = e.target.value;
    this.readAdjReason(e.target.value);
    this.setState({ AdjReasonPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteAdjReasonList = (showAutoCompleteAdjReasonList) => {
    this.setState({
      showAutoCompleteAdjReasonList: showAutoCompleteAdjReasonList,
    });
  };
  onDocumentChange = (e) => {
    let documentType = e.target.value;
    this.state.showAutoCompleteDocumentList = true;
    let tempCriteria = this.state.inventoryAdjustmentData;
    let showAutoCompleteList = this.state.showAutoCompleteDocumentList;
    if (isEmpty(documentType)) {
      this.state.showAutoCompleteDocumentList = false;
      let showAutoCompleteList = this.state.showAutoCompleteDocumentList;
      let criteria = this.state.inventoryAdjustmentData;
      criteria.documentType = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteDocumentList: showAutoCompleteList,
        inventoryAdjustmentData: criteria,
        documentPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "documentType" &&
      showAutoCompleteList === true &&
      documentType !== ""
    ) {
      this.readDocumentBySearchString(e.target.value);
    }
    tempCriteria["documentType"] = e.target.value;
    this.readDocument(documentType);
    this.setState({ inventoryAdjustmentData: tempCriteria });
  };
  readDocument = (documentType) => {
    let tempCriteria = this.state.inventoryAdjustmentData;
    tempCriteria["documentType"] = documentType;
    let documentType_List = this.state.documentTypes;
    documentType_List.map((documentType) => {
      if (documentType.code == documentType) {
        tempCriteria["documentType"] = documentType.code;
        this.state.showAutoCompleteDocumentList = false;
        let showAutoCompleteDocumentList =
          this.state.showAutoCompleteDocumentList;
        this.setState({
          showAutoCompleteDocumentList: showAutoCompleteDocumentList,
        });
      }
    });

    this.setState({ inventoryAdjustmentData: tempCriteria });
  };
  readDocumentBySearchString(searchString) {
    let documentTypeData = this.state.documentTypes;
    let simpleAutoCompleteList = new Array();
    if (documentTypeData.length > 0 && documentTypeData != null) {
      documentTypeData.map((documentTypes) => {
        let simpleItemBean = {
          code: documentTypes.code,
          description: documentTypes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletedocumentLists) =>
        simpleAutoCompletedocumentLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ documentPageListForAutoCompleteList: filteredSuggestions });
  }
  documentEnterKeyEventHandler = (e) => {
    let documentType = e.target.value;
    this.readDocument(e.target.value);
    this.setState({ documentPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteDocumentList = (showAutoCompleteDocumentList) => {
    this.setState({
      showAutoCompleteDocumentList: showAutoCompleteDocumentList,
    });
  };
  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_InventoryAdjustmentData = this.state.inventoryAdjustmentData;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
      inventoryAdjustmentData.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        inventoryAdjustmentData: inventoryAdjustmentData,
        showAutoCompleteLocationList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_InventoryAdjustmentData[e.target.name] = e.target.value;
    this.setState({ inventoryAdjustmentData: temp_InventoryAdjustmentData });
    this.readLocation(locationCode);
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.warehouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_InventoryAdjustmentData = this.state.inventoryAdjustmentData;
      temp_InventoryAdjustmentData.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let inventoryAdjustmentNewLineData =
        this.state.inventoryAdjustmentNewLineData;
      inventoryAdjustmentNewLineData.locationCode = locationBean.code;
      this.setState({
        inventoryAdjustmentData: temp_InventoryAdjustmentData,
        showAutoCompleteLocationList: showAutoCompleteList,
        inventoryAdjustmentNewLineData: inventoryAdjustmentNewLineData,
      });
    }
    this.setState({ locationData: locationData });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((location) => {
        let locationBean = {
          code: location.code,
          description: location.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  onLocationCodeChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_criteria = this.state.rollCriteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.rollCriteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        rollCriteria: criteria,
        showAutoCompleteLocationList: suggestion,
        binInventoryList: [],
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ rollCriteria: temp_criteria });
    this.readLocationCode(locationCode);
  };
  readLocationCode = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.warehouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.rollCriteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        rollCriteria: temp_criteria,
        showAutoCompleteLocationList: showAutoCompleteList,
      });
    }
    this.setState({ locationData: locationData });
  };
  locationCodeEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocationCode(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  loadBinLocations = () => {
    let criteria = new AllBinCriteriaBean();
    criteria.companyCode = this.companyCode;

    // console.log("criteria..",criteria);
    InventoryService.getAllBinList(
      criteria,
      this.loadBinLocationResponse,
      this.loadBinLocationError,
    );
  };
  loadBinLocationResponse = (response) => {
    // console.log("criteria..response",response);
    let binLists = [];
    if (response.data != null && response.data.binInfoBean != null) {
      let binList = response.data.binInfoBean.bins;
      if (binList != null || !isEmptyArray(binList)) {
        binList.map((list, i) => {
          let bean = new BaseBean();
          bean.code = list;
          binLists.push(bean);
        });
        this.setState({ binList: binLists });
      }
    }
    this.binLookup();
  };
  binLookup = () => {
    let binLookupHandler = new GenericAttributeLookupHandler(
      this.state.binList,
      "Bin",
    );
    this.setState({ binLookupHandler: binLookupHandler });
  };
  loadBinLocationError = (error) => {
    ShowError("error :", error);
  };
  binLocationCodeOnChange = (e) => {
    let binCode = e.target.value;
    this.state.showAutoCompleteBinLocationList = true;
    let temp_criteria = this.state.rollCriteria;
    let showAutoCompleteList = this.state.showAutoCompleteBinLocationList;
    if (isEmpty(binCode)) {
      this.state.showAutoCompleteBinLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteBinLocationList;
      let criteria = this.state.rollCriteria;
      criteria.binLocationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteBinLocationList: showAutoCompleteList,
        rollCriteria: criteria,
        showAutoCompleteBinLocationList: suggestion,
        binInventoryList: [],
      });
    } else if (showAutoCompleteList === true && binCode !== "") {
      this.readBinLocationBySearchString(binCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ rollCriteria: temp_criteria });
    this.readBinLocation(binCode);
  };
  readBinLocation = (binCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.binList.map((ln) => {
      if (ln.code === binCode) {
        locationBean = ln;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.rollCriteria;
      temp_criteria.binLocationCode = locationBean.code;
      this.state.showAutoCompleteBinLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteBinLocationList;
      this.setState({
        rollCriteria: temp_criteria,
        showAutoCompleteBinLocationList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean });
  };
  readBinLocationBySearchString = (searchString) => {
    let locationData = this.state.binList;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((bin) => {
        let locationBean = {
          code: bin.code,
          description: bin.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      binLocationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  binLocationEnterKeyEventHandler = (e) => {
    let binCode = e.target.value;
    this.readBinLocation(binCode);
    this.setState({
      binLocationPageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompleteBinLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteBinLocationList: showAutoCompleteList });
  };
  onPurchaseReceiptChange = (e) => {
    let purchaseOrderReceiptNumber = e.target.value;
    this.state.showAutoCompletepurchaseReceiptList = true;
    let tempCriteria = this.state.receiptCriteria;
    let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
    if (isEmpty(purchaseOrderReceiptNumber)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
      let criteria = this.state.receiptCriteria;
      criteria.purchaseOrderReceiptNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompletepurchaseReceiptList: showAutoCompleteList,
        receiptCriteria: criteria,
        purchaseReceiptPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderReceiptNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderReceiptNumber !== ""
    ) {
      this.readpurchaseReceiptBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ receiptCriteria: tempCriteria });
  };
  readpurchaseReceiptBySearchString(searchString) {
    let receiptCriteria = new PurchaseOrderReceiptSearchCriteria();
    receiptCriteria.companyCode = this.companyCode;
    receiptCriteria.purchaseOrderReceiptNumberStartsWith = searchString;
    let requestInput = new RestPurchaseOrderReceiptListRequest();
    requestInput.pageInput = new RestPageListBean();
    requestInput.searchCriteria = receiptCriteria;
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
        requestInput,
        this.loadByPurchaseOrderReceiptResponse,
        this.readBypurchaseReceiptResponseError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  loadByPurchaseOrderReceiptResponse = (response) => {
    let receiptList =
      response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
    let simpleAutoCompleteList = new Array();
    if (receiptList.length > 0 && receiptList != null) {
      receiptList.map((receipt) => {
        let simpleItemBean = {
          code: receipt.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      purchaseReceiptPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readBypurchaseReceiptResponseError = (error) => {
    ShowError("Error : ", error);
  };
  purchaseReceiptEnterKeyEventHandler = (e) => {
    let purchaseOrderReceiptNumber = e.target.value;
    let tempCriteria = this.state.receiptCriteria;
    tempCriteria.purchaseOrderReceiptNumber = purchaseOrderReceiptNumber;
    this.setState({ receiptCriteria: tempCriteria });
    this.readSelectedReceipt(e.target.value);
    this.setState({ purchaseReceiptPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompletepurchaseReceiptList = (
    showAutoCompletepurchaseReceiptList,
  ) => {
    this.setState({
      showAutoCompletepurchaseReceiptList: showAutoCompletepurchaseReceiptList,
    });
  };
  openOnHandQuantityDetailDialog() {
    this.setState({ isShowOnHandQtyPopup: true });
  }
  readOnHandQuantity = (val) => {
    if (val > 0) this.openOnHandQuantityDetailDialog();
  };
  showBinLookup = () => {
    this.setState({
      isShowBinPopup: true,
      binInventoryList: [],
      rollCriteria: new RollsSearchCriteria(),
      selectedBinRollList: [],
    });
  };
  showFabricLookup = () => {
    this.setState({
      isShowFabricPopup: true,
      fabricStyleRollList: new Array(),
      fabricRollCriteria: new SKUBatchInventorySearchCriteria(),
      selectedFabricStyleRollList: [],
    });
  };
  showReceiptLookup = () => {
    this.setState({ isShowReceiptPopup: true });
  };
  closeBinLookup = () => {
    this.setState({ isShowBinPopup: false, selectedBinRollList: [] });
  };
  closeFabricLookup = () => {
    this.setState({
      isShowFabricPopup: false,
      selectedFabricStyleRollList: [],
    });
  };
  closeRecieptLookup = () => {
    this.setState({ isShowReceiptPopup: false });
  };

  handleSortingLocationChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingLocation(sortField, sortOrder);
  };
  handleSortingLocation = (sortField, sortOrder) => {
    let invDatas = this.state.invDatas;
    if (sortField && !isEmptyArray(invDatas)) {
      const sorted = [...invDatas].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ invDatas: sorted });
    }
  };

  handleSortingOnHandChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingOnHand(sortField, sortOrder);
  };
  handleSortingOnHand = (sortField, sortOrder) => {
    let onHandQty = this.state.onHandQtyData;
    if (sortField && !isEmptyArray(onHandQty)) {
      const sorted = [...onHandQty].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ onHandQtyData: sorted });
    }
  };

  render() {
    let excelInventoryList = this.state.excelInventoryList;
    let excelIncompleteInventoryList = this.state.excelIncompleteInventoryList;
    let inventoryAdjustmentData = this.state.inventoryAdjustmentData;
    var styles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "359px",
          maxHeight: "359px",
        },
      },
    };
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <MessageBoxComponent
          isShowPopup={this.state.isShowWarningMsgPopup}
          warningMesage={this.state.warningMessage}
          title="Warning Message"
          onYesButtonClick={this.onYesButtonClick}
          onNoButtonClick={this.onNoButtonClick}
          closeMessageModelCallBack={this.closeMessageModelCallBack}
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowExcelDataPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Inventory Adjustment Roll Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addExcelDataLine(e)}
              >
                Add line
              </Button>
            </div>
          }
          content={
            <div className="header_div">
              <Row>
                <Col sm="1">
                  <FormLabel>Inventory</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={inventoryAdjustmentData.code}
                    disabled={true}
                  ></InputTextbox>
                </Col>
                <Col sm="2">
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    size="sm1"
                    onClick={(e) => this.selectAllExcelLine(e)}
                  >
                    SelectAll
                  </Button>
                </Col>
                <Col sm="2">
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    size="sm1"
                    onClick={(e) => this.unSelectAllExcelLine(e)}
                  >
                    UnSelectAll
                  </Button>
                </Col>
              </Row>
              <Row>
                <div>
                  <div>
                    <FormLabel>InventoryLines</FormLabel>
                    {this.state.excelInventoryList != null &&
                      !isEmptyArray(this.state.excelInventoryList) && (
                        <div className="div_Custom">
                          {/* <EditableDataGrid
                            customStyles={styles}
                            columnsList={this.excelListColumnDefinitions()}
                            dataList={excelInventoryList}
                          /> */}
                          <CustomTable
                            columns={this.excelListColumns()}
                            data={excelInventoryList}
                            label={"InventoryLines"}
                          />
                        </div>
                      )}
                  </div>
                  <div>
                    <FormLabel>InCompleteInventoryLines</FormLabel>
                    {this.state.excelInventoryList != null &&
                      !isEmptyArray(this.state.excelInventoryList) && (
                        <div className="div_Custom">
                          {/* <EditableDataGrid
                            customStyles={styles}
                            columnsList={this.excelListColumnDefinitions()}
                            dataList={excelIncompleteInventoryList}
                          /> */}
                          <CustomTable
                            columns={this.excelListColumns()}
                            data={excelIncompleteInventoryList}
                            label={"InCompleteInventoryLines"}
                          />
                        </div>
                      )}
                  </div>
                </div>
              </Row>
            </div>
          }
        />

        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editInventoryAdjustment}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.inventoryAdjustmentLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          isSpecialViewMode={this.state.isSpecialViewMode}
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isResetView={this.state.isResetView}
        />
        {!this.state.isInventoryAdjustmentListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              extend_toolbar={
                <>
                  {" "}
                  {this.state.isShowCancelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.cancelInventoryAdjustment(e)}
                    >
                      Cancel
                    </Button>
                  )}
                </>
              }
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              isShowPDFButton={this.state.isShowPDFReportButton}
              pageTitle={this.state.pageTitle}
            />
          )}
        {this.state.isInventoryAdjustmentListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <InventoryAdjustmentListForm
              {...this.state}
              inventory_adj_list={this.state.inventory_adj_list}
              pageList={this.state.pageList}
              criteria={this.state.criteria}
              filterInventoryAdjustment={this.filterInventoryAdjustment}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              editInventoryAdjustment={this.editInventoryAdjustment}
              resetfilteredAdjustment={this.resetfilteredAdjustment}
              isLoading={this.state.isLoading}
              searchOnChange={this.searchOnChange}
              handleSortingChange={this.handleSortingChange}
            />
          )}
        {this.state.isAdjustementEntryFormOpen && (
          <InventoryAdjustmentForm
            {...this.state}
            inventoryAdjustmentData={this.state.inventoryAdjustmentData}
            inventoryAdjustmentNewLineData={
              this.state.inventoryAdjustmentNewLineData
            }
            showHide={this.state.isInventoryAdjustmentAddOpen}
            closeInventoryAdjustmentForm={this.closeInventoryAdjustmentForm}
            disableInventoryAdjustmentFormFields={this.state.isDisabledFields}
            isListMode={this.state.isListMode}
            isEntryMode={this.state.isEntryMode}
            saveInventoryAdjustment={this.saveInventoryAdjustment}
            closeEntryForm={this.closeEntryForm}
            inventoryAdjustmentReasons={this.state.inventoryAdjustmentReasons}
            warehouses={this.state.warehouses}
            documentTypes={this.state.documentTypes}
            fabricStyle_List={this.state.fabricStyle_List}
            onLineChange={this.onLineChange}
            onChange={this.onChange}
            fabricCodeOnChange={this.fabricCodeOnChange}
            addOrUpdateLineChange={this.addOrUpdateLineChange}
            addOrUpdateRollLineChange={this.addOrUpdateRollLineChange}
            fabricStyleColorCodeRef={this.fabricStyleColorCodeRef}
            fabricStyleCodeRef={this.fabricStyleCodeRef}
            clearLineValues={this.clearLineValues}
            nodeOnSelect={this.nodeOnSelect}
            selectedNodeKey={this.state.selectedNodeKey}
            fetchRolls={this.fetchRolls}
            rollCriteria={this.state.rollCriteria}
            rollCriteriaOnChange={this.rollCriteriaOnChange}
            binInventoryList={this.state.binInventoryList}
            fabricRollCriteriaOnChange={this.fabricRollCriteriaOnChange}
            fabricRollColorOnChange={this.fabricRollColorOnChange}
            fabricFetchRolls={this.fabricFetchRolls}
            makeZero={this.makeZero}
            binMakeZero={this.binMakeZero}
            binLocClear={this.binLocClear}
            fabricRollCriteria={this.state.fabricRollCriteria}
            fabricStyleRollList={this.state.fabricStyleRollList}
            receiptList={this.state.receiptList}
            receiptCriteria={this.state.receiptCriteria}
            receiptOnChange={this.receiptOnChange}
            loadReceiptRolls={this.loadReceiptRolls}
            binSelectAll={this.binSelectAll}
            binUnSelectAll={this.binUnSelectAll}
            fabricSelectAll={this.fabricSelectAll}
            fabricUnSelectAll={this.fabricUnSelectAll}
            binAddLine={this.binAddLine}
            fabricRollAddLine={this.fabricRollAddLine}
            fabricLineCheck={this.fabricLineCheck}
            selectLineCheck={this.selectLineCheck}
            getLineDetails={this.getLineDetails}
            getRollSkuLineDetails={this.getRollSkuLineDetails}
            rollSkuOnChange={this.rollSkuOnChange}
            rollSkuNumberOnChange={this.rollSkuNumberOnChange}
            deleteAdjustmentLines={this.deleteAdjustmentLines}
            deleteAdjustmentNewLines={this.deleteAdjustmentNewLines}
            uploadExcelFile={this.uploadExcelFile}
            clearRollLineValues={this.clearRollLineValues}
            clearPOReciept={this.clearPOReciept}
            onDocumentChange={this.onDocumentChange}
            documentEnterKeyEventHandler={this.documentEnterKeyEventHandler}
            displayAutoCompleteDocumentList={
              this.displayAutoCompleteDocumentList
            }
            onAdjReasonChange={this.onAdjReasonChange}
            AdjReasonEnterKeyEventHandler={this.AdjReasonEnterKeyEventHandler}
            displayAutoCompleteAdjReasonList={
              this.displayAutoCompleteAdjReasonList
            }
            locationCodeOnChange={this.locationCodeOnChange}
            locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
            displayAutoCompleteLocationList={
              this.displayAutoCompleteLocationList
            }
            onLocationCodeChange={this.onLocationCodeChange}
            locationCodeEnterKeyEventHandler={
              this.locationCodeEnterKeyEventHandler
            }
            binLocationCodeOnChange={this.binLocationCodeOnChange}
            binLocationEnterKeyEventHandler={
              this.binLocationEnterKeyEventHandler
            }
            displayAutoCompleteBinLocationList={
              this.displayAutoCompleteBinLocationList
            }
            onPurchaseReceiptChange={this.onPurchaseReceiptChange}
            purchaseReceiptEnterKeyEventHandler={
              this.purchaseReceiptEnterKeyEventHandler
            }
            displayAutoCompletepurchaseReceiptList={
              this.displayAutoCompletepurchaseReceiptList
            }
            fabricRollColorEnterKeyEventHandler={
              this.fabricRollColorEnterKeyEventHandler
            }
            fabricRollEnterKeyEventHandler={this.fabricRollEnterKeyEventHandler}
            displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
            displayAutoCompleteFabricColorList={
              this.displayAutoCompleteFabricColorList
            }
            fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
            fabricColorEnterKeyEventHandler={
              this.fabricColorEnterKeyEventHandler
            }
            onFabricColorCodeChange={this.onFabricColorCodeChange}
            readOnHandQuantity={this.readOnHandQuantity}
            showBinLookup={this.showBinLookup}
            showFabricLookup={this.showFabricLookup}
            showReceiptLookup={this.showReceiptLookup}
            closeBinLookup={this.closeBinLookup}
            closeFabricLookup={this.closeFabricLookup}
            closeRecieptLookup={this.closeRecieptLookup}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            hideAlertCallBack={this.hideAlertCallBack}
            handleSortingLocationChange={this.handleSortingLocationChange}
            onHandQtyData={this.state.onHandQtyData}
            handleSortingOnHandChange={this.handleSortingOnHandChange}
          />
        )}
        <ReasonCaptureComponent
          ref={this.cancelReasonDialogRef}
          reasons={this.state.inventoryAdjustmentReasons}
          reasonData={this.state.reasonData}
          title="Adjustment Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
      </div>
    );
  }
}
class InventoryAdjustmentListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adjustmentCriteria: new FabricStyleInventoryAdjustmentSearchCriteria(),
      filter: "",
      pageList: this.props.pageList,
    };
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  searchOnChange = (e) => {
    this.props.searchOnChange(e);
  };
  filterInventoryAdjustment = (e) => {
    if (e.detail == 1) this.props.filterInventoryAdjustment();
  };
  resetfilteredAdjustment = (e) => {
    let criteria = this.props.criteria;
    if (e.detail == 1) this.props.resetfilteredAdjustment(criteria);
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  editInventoryAdjustment = (e, val, rowData) => {
    if (e.detail == 1) this.props.editInventoryAdjustment(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterInventoryAdjustment();
    }
  };

  inv_adj_Columns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("AdjustmentCode", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.editInventoryAdjustment, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Reason", "adjustmentReason", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Warehouse", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DocumentNumber", "documentNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DocumentType", "documentType", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreatedDate", "createdDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    return columns;
  };

  render() {
    let inventory_adj_list = this.props.inventory_adj_list;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let isLoading = this.props.isLoading;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="adjustmentCodeStartsWith"
                type="text"
                value={criteria.adjustmentCodeStartsWith}
                placeholder="Enter Value to Filter.."
                onChange={this.searchOnChange}
                onKeyDown={this.onKeyDown}
              />
              <Button onClick={(e) => this.filterInventoryAdjustment(e)}>
                Filter
              </Button>
              <Button onClick={(e) => this.resetfilteredAdjustment(e)}>
                Reset
              </Button>
            </span>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>

        <div className="mt-3">
          <CustomTable
            data={inventory_adj_list}
            columns={this.inv_adj_Columns()}
            enableHighlight={true} // Boolean flag controlling highlight execution
            //  searchText={pickTicketCriteria.searchName} // Search input text
          />
        </div>
      
      </div>
    );
  }
}
class InventoryAdjustmentForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
    this.fabricStyleColorCodeRef = this.props.fabricStyleColorCodeRef;
    this.fabricStyleCodeRef = this.props.fabricStyleCodeRef;
    this.receiptCodeRef = React.createRef();
    this.warehouseRef = React.createRef();
    this.adjustmentReasonRef = React.createRef();
    this.documentTypeRef = React.createRef();
    this.fabricCodeRef = React.createRef();
    this.rollSkuRef = React.createRef();
  }
  getEmptyView() {
    return <div></div>;
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setInputFocus();
  }
  setInputFocus = () => {
    if (this.props.moduleKeyCode === "NEW") {
      this.adjustmentReasonRef.current.focus();
    }
  };
  initLookupHandlers = () => {
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.warehouses,
      "Warehouse",
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let adjustmentReasonLookupHandler = new GenericAttributeLookupHandler(
      this.props.inventoryAdjustmentReasons,
      "Adjustment Reason",
    );
    this.setState({
      adjustmentReasonLookupHandler: adjustmentReasonLookupHandler,
    });
    let documentTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.documentTypes,
      "Document Type",
    );
    this.setState({ documentTypeLookupHandler: documentTypeLookupHandler });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.props.is3PL ? "Item" : "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let purchaseReceiptLookupHandler = new PurchaseOrderReceiptLookupHandler(
      this.companyCode,
      "Purchase Receipt",
    );
    this.setState({
      purchaseReceiptLookupHandler: purchaseReceiptLookupHandler,
    });
  };
  rollCriteriaOnChange = (e) => {
    this.props.rollCriteriaOnChange(e);
  };
  fabricRollCriteriaOnChange = (e) => {
    this.props.fabricRollCriteriaOnChange(e);
  };
  fabricRollColorOnChange = (e) => {
    this.props.fabricRollColorOnChange(e);
  };
  fabricRollEnterKeyEventHandler = (e) => {
    this.props.fabricRollEnterKeyEventHandler(e);
  };
  fabricRollColorEnterKeyEventHandler = (e) => {
    this.props.fabricRollColorEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricList = (list) => {
    this.props.displayAutoCompleteFabricList(list);
  };
  displayAutoCompleteFabricColorList = (list) => {
    this.props.displayAutoCompleteFabricColorList(list);
  };
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  fabricCodeOnChange = (e) => {
    this.props.fabricCodeOnChange(e);
  };
  addUpdateLine = (e) => {
    if (e.detail <= 1) this.props.addOrUpdateLineChange(e);
  };
  addUpdateRollLine = (e) => {
    if (e.detail <= 1) this.props.addOrUpdateRollLineChange(e);
  };
  rollSkuOnChange = (e) => {
    this.props.rollSkuOnChange(e);
  };
  rollSkuNumberOnChange = (e) => {
    this.props.rollSkuNumberOnChange(e);
  };
  onrollSkuNumberBlur = (e) => {
    this.props.onrollSkuNumberBlur(e);
  };
  receiptOnChange = (e) => {
    this.props.receiptOnChange(e);
  };
  clearLineValues = (e) => {
    if (e.detail <= 1) this.props.clearLineValues();
  };
  clearRollLineValues = (e) => {
    if (e.detail <= 1) this.props.clearRollLineValues();
  };
  selectLineCheck = (e, rowData) => {
    this.props.selectLineCheck(e, rowData);
  };
  fabricLineCheck = (e, rowData) => {
    this.props.fabricLineCheck(e, rowData);
  };
  handleLineNumberClick = (e, val, rowData) => {
    if (this.props.selectedNodeKey == "headerView") {
      this.props.getLineDetails(rowData);
    } else if (this.props.selectedNodeKey == "rollSkuView") {
      this.props.getRollSkuLineDetails(rowData);
    }
  };
  deleteClickCallback = (e, val, rowData) => {
    if (this.props.selectedNodeKey == "headerView") {
      this.props.deleteAdjustmentNewLines(rowData);
    } else if (this.props.selectedNodeKey == "rollSkuView") {
      this.props.deleteAdjustmentLines(rowData);
    }
  };
  adjustmentLineColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Ln#", "lineNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.handleLineNumberClick, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "ItemName" : "FabricStyleName",
          "fabricStyleShortName",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.props.is3PL ? "Seq#" : "Roll#", "rollNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VENDORLOT#", "vendorBatchNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Bin#", "binLocation", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Adjusted Qty#", "quantity", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM#", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    {
      !this.props.is3PL
        ? columns.push(
            new ColumnDefinition()
              .setDetails("IsCloseOut", "isCloseOutInventory", true)
              .setStyleDetails("left", "", "", "wt-2", "wt-2")
              .setInputDetails(
                false,
                false,
                true,
                null,
                // this.closeOutCheck,
                null,
              )
              .setDisabled(true),
          )
        : columns.push(
            new ColumnDefinition()
              .setDetails("", <DeleteIcon />, false)
              .setStyleDetails("left", "", "", "wt-2", "wt-2")
              .setClickDetails(
                false,
                true,
                this.deleteClickCallback,
                <DeleteIcon />,
              ),
          );
    }

    return columns;
  };
  binLineColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setInputDetails(false, false, true, null, this.selectLineCheck, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Bin#", "aisleInfoText", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "ItemName" : "FabricStyleName",
          "fabricStyleName",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.props.is3PL ? "Seq#" : "Roll#", "rollNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("VENDORLOT", "vendorBatchNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("WH", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty#", "onHandQuantity", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Adjusted Qty#", "quantity", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM#", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    return columns;
  };

  fabricLineColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setInputDetails(false, false, true, null, this.fabricLineCheck, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "ItemName" : "FabricStyleName",
          "fabricStyleName",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.props.is3PL ? "Seq#" : "Roll#", "rollNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VENDORLOT", "vendorBatchNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Bin#", "binLocation", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("WH", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty#", "onHandQuantity", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Adjusted Qty#", "quantity", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM#", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    return columns;
  };
  lineColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Ln#",
        "lineNumber",
        0,
        true,
        this.handleLineNumberClick,
      ),
    );
    if (this.props.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails("item", "fabricStyleCode"),
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "FabricStyleCode",
          "fabricStyleCode",
        ),
      );
    }
    if (this.props.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "Item Name",
          "fabricStyleShortName",
        ),
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "Name",
          "fabricStyleShortName",
        ),
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Color",
        "fabricStyleColorCode",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("WidthCode", "widthCode"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Seq#" : "Roll#",
        "rollNumber",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "VENDORLOT#",
        "vendorBatchNumber",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Bin#", "binLocation"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Adjusted Qty#", "quantity", 1),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UOM#", "uomCode"),
    );
    if (!this.props.is3PL) {
      columnList.push(
        new DataGridColumnDefinition()
          .setDetails(
            "IsCloseOut",
            "isCloseOutInventory",
            0,
            false, //set hyperlink false
            null, //set hyperLink call back null
            false,
            null,
          )
          .setEditableDetails(
            false,
            "",
            null,
            false,
            null,
            true,
            null,
            //this.closeOutCheck,
          ),
      );
    }
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          <DeleteIcon />,
          // true,
          1,
          false,
          null,
          false,
          null, //image link call back
          "1em", //min-width
          "3%", //max-width
          false,
          null,
          false,
        )
        .setEditableDetails(
          false,
          "",
          null,
          true,
          this.deleteClickCallback,
          false,
          null,
        ),
    );
    return columnList;
  };
  binLineColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null,
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.selectLineCheck,
        ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Bin#", "aisleInfoText"),
    );
    if (this.props.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Item", "fabricStyleCode"),
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "FabricStyleCode",
          "fabricStyleCode",
        ),
      );
    }
    if (this.props.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "Item Name",
          "fabricStyleName",
        ),
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Name", "fabricStyleName"),
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Color",
        "fabricStyleColorCode",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("WidthCode", "widthCode"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Seq#" : "Roll#",
        "rollNumber",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "VENDORLOT#",
        "vendorBatchNumber",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("WH", "locationCode"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "OnHandQty#",
        "onHandQuantity",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Adjusted Qty#", "quantity", 1),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UOM#", "uomCode"),
    );
    return columnList;
  };
  fabricLineColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isActive",
          // true,
          0,
          false,
          null,
          false,
          null, //image link call back
          "1em", //min-width
          "5%", //max-width
          false,
          null,
          false,
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.fabricLineCheck,
          null,
        ),
    );
    if (this.props.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "Item",
          "fabricStyleCode",
          0,
          false,
          null,
          false,
          null, //image link call back
        ),
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "FabricStyle#",
          "fabricStyleCode",
          1,
          false,
          null,
          false,
          null, //image link call back
        ),
      );
    }
    if (this.props.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "Item Name",
          "fabricStyleName",
        ),
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Name", "fabricStyleName"),
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Color",
        "fabricStyleColorCode",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("WidthCode", "widthCode"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Seq#" : "Roll#",
        "rollNumber",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "VENDORLOT#",
        "vendorBatchNumber",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Bin#", "binLocation"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("WH", "locationCode"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "OnHandQty#",
        "onHandQuantity",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Adjusted Qty#", "quantity", 1),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UOM#", "uomCode"),
    );
    return columnList;
  };
  nodeOnSelect = (selectedNode) => {
    this.props.nodeOnSelect(selectedNode);
  };

  handleFocus = (event) => {
    event.target.select();
  };
  handleKeyDown = (event) => {
    if (event.keyCode == 13) {
    }
  };
  showBinLookup = () => {
    this.props.showBinLookup();
  };
  showFabricLookup = () => {
    this.props.showFabricLookup();
  };
  showReceiptLookup = () => {
    if (this.receiptCodeRef.current != null) {
      this.receiptCodeRef.current.clear();
    }
    this.props.showReceiptLookup();
  };
  closeAlertModalCallBack = () => {
    this.props.closeAlertModalCallBack(false);
    this.props.clearPOReciept();
  };
  loadBinInventory = (e) => {
    if (e.detail <= 1) this.showBinLookup();
  };
  addRollFabricStyle = (e) => {
    if (e.detail <= 1) this.showFabricLookup();
  };
  loadPurchaseReceipt = (e) => {
    if (e.detail <= 1) this.showReceiptLookup();
  };
  fetchRolls = (e) => {
    if (e.detail <= 1) this.props.fetchRolls();
  };
  fabricFetchRolls = (e) => {
    if (e.detail <= 1) this.props.fabricFetchRolls();
  };
  makeZero = (e) => {
    if (e.detail <= 1) this.props.makeZero();
  };
  binMakeZero = (e) => {
    if (e.detail <= 1) this.props.binMakeZero();
  };
  binLocClear = (e) => {
    if (e.detail <= 1) this.props.binLocClear();
  };
  binSelectAll = (e) => {
    if (e.detail <= 1) this.props.binSelectAll();
  };
  binUnSelectAll = (e) => {
    if (e.detail <= 1) this.props.binUnSelectAll();
  };
  fabricSelectAll = (e) => {
    if (e.detail <= 1) this.props.fabricSelectAll();
  };
  fabricUnSelectAll = (e) => {
    if (e.detail <= 1) this.props.fabricUnSelectAll();
  };
  loadReceiptRolls = (e) => {
    if (e.detail <= 1) this.props.loadReceiptRolls();
    this.props.closeRecieptLookup();
    this.props.clearPOReciept();
  };
  binAddLine = (e) => {
    if (e.detail == 1) this.props.binAddLine(e);
    this.props.closeBinLookup();
  };
  fabricRollAddLine = (e) => {
    if (e.detail == 1) this.props.fabricRollAddLine(e);
    this.props.closeFabricLookup();
  };
  readOnHandQuantity = (e, val) => {
    if (e.detail == 1) this.props.readOnHandQuantity(val);
  };
  onExcelClick = (e) => {
    if (e.detail <= 1) {
      const input = document.getElementById("file-input");
      if (input) {
        input.click();
      }
    }
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  onDocumentChange = (e) => {
    this.props.onDocumentChange(e);
  };
  documentEnterKeyEventHandler = (e) => {
    this.props.documentEnterKeyEventHandler(e);
  };
  displayAutoCompleteDocumentList = (list) => {
    this.props.displayAutoCompleteDocumentList(list);
  };
  onAdjReasonChange = (e) => {
    this.props.onAdjReasonChange(e);
  };
  AdjReasonEnterKeyEventHandler = (e) => {
    this.props.AdjReasonEnterKeyEventHandler(e);
  };
  displayAutoCompleteAdjReasonList = (list) => {
    this.props.displayAutoCompleteAdjReasonList(list);
  };
  locationCodeOnChange = (e) => {
    this.props.locationCodeOnChange(e);
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  displayAutoCompleteLocationList = (list) => {
    this.props.displayAutoCompleteLocationList(list);
  };
  onLocationCodeChange = (e) => {
    this.props.onLocationCodeChange(e);
  };
  locationCodeEnterKeyEventHandler = (e) => {
    this.props.locationCodeEnterKeyEventHandler(e);
  };
  binLocationCodeOnChange = (e) => {
    this.props.binLocationCodeOnChange(e);
  };
  binLocationEnterKeyEventHandler = (e) => {
    this.props.binLocationEnterKeyEventHandler(e);
  };
  displayAutoCompleteBinLocationList = (list) => {
    this.props.displayAutoCompleteBinLocationList(list);
  };
  onPurchaseReceiptChange = (e) => {
    this.props.onPurchaseReceiptChange(e);
  };
  purchaseReceiptEnterKeyEventHandler = (e) => {
    this.props.purchaseReceiptEnterKeyEventHandler(e);
  };
  displayAutoCompletepurchaseReceiptList = (list) => {
    this.props.displayAutoCompletepurchaseReceiptList(list);
  };
  onFabricColorCodeChange = (e) => {
    this.props.onFabricColorCodeChange(e);
  };
  fabricColorEnterKeyEventHandler = (e) => {
    this.props.fabricColorEnterKeyEventHandler(e);
  };
  fabricEnterKeyEventHandler = (e) => {
    this.props.fabricEnterKeyEventHandler(e);
  };
  hideAlertCallBack = (isDisplayed) => {
    this.props.hideAlertCallBack(isDisplayed);
  };
  handleSortingLocationChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingLocationChange(accessor);
  };
  render() {
    let inventoryAdjustmentdata = null;
    let inventoryAdjustmentLineData = this.props.inventoryAdjustmentLineData;
    let inventoryAdjustmentNewLineData =
      this.props.inventoryAdjustmentNewLineData;
    let warehouses = this.props.warehouses;
    let documentTypes = this.props.documentTypes;
    let fabricStyle_List = this.props.fabricStyle_List;
    let fabricStyleSkuList = this.props.currentFabricStyleSkuList;
    if (!fabricStyleSkuList) {
      fabricStyleSkuList = new Array();
    }
    let disableInventoryAdjustmentFormFields =
      this.props.disableInventoryAdjustmentFormFields;
    inventoryAdjustmentdata = this.props.inventoryAdjustmentData;
    let adjustmentLines = inventoryAdjustmentdata.adjustmentLines;
    if (adjustmentLines == null && adjustmentLines == undefined) {
      adjustmentLines = new Array();
    }
    let adjustmentNewLines = inventoryAdjustmentdata.adjustmentNewLines;
    if (adjustmentNewLines == null && adjustmentNewLines == undefined) {
      adjustmentNewLines = new Array();
    }

    let binInventoryList = this.props.binInventoryList;
    let fabricStyleRollList = this.props.fabricStyleRollList;
    let receiptList = this.props.receiptList;
    let rollCriteria = this.props.rollCriteria;
    let fabricRollCriteria = this.props.fabricRollCriteria;
    let receiptCriteria = this.props.receiptCriteria;
    var styles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "170px",
          maxHeight: "170px",
          overflowY: "auto",
        },
      },
    };
    var newLinestyles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "250px",
          maxHeight: "250px",
          overflowY: "auto",
        },
      },
    };
    const textAreaStyle = {
      maxHeight: "9em",
      width: "40em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    return (
      <div>
        <div className="header_div">
          <Row>
            <Col sm="1">
              <FormLabel>Adjustment Reason</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onAdjReasonChange}
                ref={this.adjustmentReasonRef}
                name="adjustmentReason"
                placeholder="adjustmentReason"
                value={inventoryAdjustmentdata.adjustmentReason}
                lookupRequired={true}
                lookupHandler={this.state.adjustmentReasonLookupHandler}
                enterKeyEventHandler={this.AdjReasonEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.AdjReasonPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteAdjReasonList}
                showAutoCompleteList={this.props.showAutoCompleteAdjReasonList}
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>Location Code </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.locationCodeOnChange}
                ref={this.warehouseRef}
                name="locationCode"
                placeholder="locationCode"
                value={inventoryAdjustmentdata.locationCode}
                lookupRequired={true}
                lookupHandler={this.state.warehouseLookupHandler}
                enterKeyEventHandler={this.locationEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.locationPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteLocationList}
                showAutoCompleteList={this.props.showAutoCompleteLocationList}
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>DocumentType</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onDocumentChange}
                name="documentType"
                placeholder="documentType"
                value={inventoryAdjustmentdata.documentType}
                lookupRequired={true}
                lookupHandler={this.state.documentTypeLookupHandler}
                enterKeyEventHandler={this.documentEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.documentPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteDocumentList}
                showAutoCompleteList={this.props.showAutoCompleteDocumentList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>Document#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="documentNumber"
                placeholder="Enter documentNumber"
                onChange={this.onChange}
                readOnly={disableInventoryAdjustmentFormFields}
                value={inventoryAdjustmentdata.documentNumber}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Remarks</FormLabel>{" "}
            </Col>
            <Col sm="5">
              <textarea
                style={textAreaStyle}
                className="form-control"
                name="remarks"
                type="text"
                placeholder="Enter remarks"
                onChange={this.onChange}
                value={inventoryAdjustmentdata.remarks}
                disabled={isDisabledFields}
              />
            </Col>
            {this.props.isLoadExcelButton && (
              <Col sm="2">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm"
                  onClick={(e) => this.onExcelClick(e)}
                >
                  Load From Excel
                </Button>
                <input
                  type="file"
                  id="file-input"
                  style={{ display: "none" }}
                  onChange={this.uploadExcelFile}
                  accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                />
              </Col>
            )}
          </Row>
        </div>
        <div className="header_div">
          <Row>
            <Col sm="2" className="title_text_div">
              <FormLabel className="label_head">Inv Adjustment Lines</FormLabel>
            </Col>
            {this.props.isLoadReceiptButton && (
              <Col sm="3">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm"
                  onClick={(e) => this.loadPurchaseReceipt(e)}
                >
                  Load From Purchase Receipt
                </Button>
              </Col>
            )}
            {this.props.isLoadReceiptButton && (
              <Col sm="3">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm"
                  onClick={(e) => this.addRollFabricStyle(e)}
                >
                  {this.props.is3PL
                    ? " Add Rolls From Item"
                    : " Add Rolls From FabricStyle"}
                </Button>
              </Col>
            )}
            {this.props.isLoadReceiptButton && (
              <Col sm="3">
                <Button
                  id="fabric_Add_Button"
                  className="enterFocus"
                  size="sm"
                  onClick={(e) => this.loadBinInventory(e)}
                >
                  Load From BinInventory
                </Button>
              </Col>
            )}
          </Row>
          {this.props.isShowNodes && (
            <BaseNodeBar
              nodeList={this.props.nodeList}
              selectedModuleKey={this.props.selectedNodeKey}
              nodeOnSelect={this.nodeOnSelect}
            />
          )}
          <div>
            {this.props.selectedNodeKey == "headerView" ? (
              <div className="div_Custom">
                {/* <EditableDataGrid
                  styles={styles}
                  columnsList={this.lineColumnDefinitions()}
                  dataList={adjustmentNewLines}
                /> */}
                <CustomTable
                  columns={this.adjustmentLineColumns()}
                  data={adjustmentNewLines}
                  label={"Adjustment Lines"}
                />
              </div>
            ) : (
              <div className="div_Custom">
                {/* <EditableDataGrid
                  styles={styles}
                  columnsList={this.lineColumnDefinitions()}
                  dataList={adjustmentLines}
                /> */}
                <CustomTable
                  columns={this.adjustmentLineColumns()}
                  data={adjustmentLines}
                  label={"Adjustment Lines"}
                />
              </div>
            )}
            <div>
              <Row>
                <Col sm="2" className="title_text_div">
                  <FormLabel className="label_head">
                    Inv Adjustment Detail
                  </FormLabel>
                </Col>
              </Row>
            </div>
          </div>
          {this.props.selectedNodeKey == "headerView" ? (
            <div className="div_inline">
              <div className="div_75_no_overflow">
                <Row>
                  <Col>
                    <FormLabel>Line#</FormLabel>{" "}
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="lineNumber"
                      type="text"
                      onChange={this.onLineChange}
                      readOnly={true}
                      value={inventoryAdjustmentNewLineData.lineNumber}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col className="align-fabricStyles-left" sm="1">
                    {this.props.is3PL ? (
                      <FormLabel>Item</FormLabel>
                    ) : (
                      <FormLabel>FabricStyle</FormLabel>
                    )}
                  </Col>
                  <Col sm="2">
                    {/* <InputTextbox
                      onChange={this.fabricCodeOnChange}
                      ref={this.fabricStyleCodeRef}
                      name="fabricStyleCode"
                      placeholder="fabricStyleCode"
                      value={inventoryAdjustmentNewLineData.fabricStyleCode}
                      lookupRequired={true}
                      lookupHandler={this.state.fabricLookupHandler}
                      disabled={isDisabledFields}
                    ></InputTextbox> */}
                    <InputTextbox
                      onChange={this.fabricCodeOnChange}
                      ref={this.fabricStyleCodeRef}
                      name="fabricStyleCode"
                      placeholder={this.props.is3PL ? "Item" : "FabricStyle"}
                      value={inventoryAdjustmentNewLineData.fabricStyleCode}
                      lookupRequired={true}
                      lookupHandler={this.state.fabricLookupHandler}
                      enterKeyEventHandler={this.fabricEnterKeyEventHandler}
                      autoCompleteListData={
                        this.props.fabricPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteFabricList
                      }
                      showAutoCompleteList={
                        this.props.showAutoCompleteFabricList
                      }
                      disabled={isDisabledFields}
                      isMandatory={true}
                    ></InputTextbox>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      name="fabricStyleShortName"
                      type="text"
                      value={
                        inventoryAdjustmentNewLineData.fabricStyleShortName
                      }
                      readOnly={true}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Color</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      //ref={this.fabricStyleColorCodeRef}
                      name="fabricStyleColorCode"
                      type="text"
                      placeholder="Enter Color"
                      value={
                        inventoryAdjustmentNewLineData.fabricStyleColorCode
                      }
                      onChange={this.onFabricColorCodeChange}
                      lookupRequired={this.props.isShowColorLookup}
                      lookupHandler={this.props.colorLookupHandler}
                      enterKeyEventHandler={
                        this.fabricColorEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.fabricColourPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteFabricColorList
                      }
                      showAutoCompleteList={
                        this.props.showAutoCompleteFabricColorList
                      }
                      disabled={!this.props.isShowColorLookup}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Width</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="widthCode"
                      type="text"
                      placeholder="Enter widthCode"
                      value={inventoryAdjustmentNewLineData.widthCode}
                      onChange={this.onLineChange}
                      readOnly={true}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>UOM</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="uomCode"
                      type="text"
                      placeholder="Enter uomCode"
                      value={inventoryAdjustmentNewLineData.uomCode}
                      onChange={this.onLineChange}
                      readOnly={true}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.readOnHandQuantity(
                          e,
                          inventoryAdjustmentNewLineData.onHandQuantity,
                        )
                      }
                    >
                      OnHandQty
                    </FormLabel>
                  </Col>
                  <Col sm="2">
                    <NumberFormatInputbox
                      name={"onHandQuantity"}
                      onChange={this.onLineChange}
                      placeholder="Enter orderQuantity"
                      value={inventoryAdjustmentNewLineData.onHandQuantity}
                      className="text-right"
                      decimalScale={2}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>AdjustQty</FormLabel>
                  </Col>
                  <Col sm="2">
                    <NumberFormatInputbox
                      name={"quantity"}
                      onChange={this.onLineChange}
                      value={inventoryAdjustmentNewLineData.quantity}
                      className="text-right"
                      decimalScale={2}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Location</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="locationCode"
                      type="text"
                      placeholder="Enter locationCode"
                      value={inventoryAdjustmentNewLineData.locationCode}
                      onChange={this.onLineChange}
                      readOnly={true}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>
                      {this.state.is3PL ? "Inventory#" : "RollSKU"}
                    </FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="rollSkuNumber"
                      type="text"
                      placeholder={
                        this.props.is3PL ? "Enter Inventory#" : "Enter rollSKU#"
                      }
                      value={inventoryAdjustmentNewLineData.rollSkuNumber}
                      onChange={this.onLineChange}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>{this.props.is3PL ? "Seq#" : "Roll#"}</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="rollNumber"
                      type="text"
                      placeholder={
                        this.props.is3PL ? "Enter Seq" : "Enter Roll"
                      }
                      value={inventoryAdjustmentNewLineData.rollNumber}
                      onChange={this.onLineChange}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>
                      {this.props.is3PL ? "SkuQty" : "Roll SKUQty"}
                    </FormLabel>
                  </Col>
                  <Col sm="2">
                    <NumberFormatInputbox
                      name={"rollSkuOnHandQuantity"}
                      onChange={this.onLineChange}
                      value={
                        inventoryAdjustmentNewLineData.rollSkuOnHandQuantity
                      }
                      className="text-right"
                      decimalScale={2}
                      disabled={true}
                      readOnly={true}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Bin Loc</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="binLocation"
                      type="text"
                      placeholder="Enter binLocation"
                      value={inventoryAdjustmentNewLineData.binLocation}
                      onChange={this.onLineChange}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>VENDOR LOT</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="vendorBatchNumber"
                      type="text"
                      placeholder="Enter VENDOR LOT"
                      value={inventoryAdjustmentNewLineData.vendorBatchNumber}
                      onChange={this.onLineChange}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />
                  </Col>
                  {!is3PL ? (
                    <>
                      <Col sm="1">
                        <FormLabel>Box</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="boxNumber"
                          type="text"
                          placeholder="Enter boxNumber"
                          value={inventoryAdjustmentNewLineData.boxNumber}
                          onChange={this.onLineChange}
                          disabled={isDisabledFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>IsCloseOut</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputCheckbox
                          name="isCloseOutInventory"
                          type="checkbox"
                          checked={
                            inventoryAdjustmentNewLineData.isCloseOutInventory
                          }
                          onChange={this.onLineChange}
                          disabled={isDisabledFields}
                        />
                      </Col>
                    </>
                  ) : null}
                </Row>
                {this.props.isshowaddorupdatebutton ? (
                  <div>
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      onClick={(e) => this.addUpdateLine(e)}
                    >
                      Add/Update
                    </Button>
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      onClick={(e) => this.clearLineValues(e)}
                    >
                      Clear
                    </Button>
                  </div>
                ) : null}
              </div>
              <div className="div_25_no_overflow">
                <div className="table_Medium">
                  <Table id="fabrics_tables">
                    <thead>
                      <th
                        onClick={(e) =>
                          this.handleSortingLocationChange(e, "locationCode")
                        }
                      >
                        Location
                        {this.props.order === "desc" &&
                        this.props.sortField === "locationCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLocationChange(
                            e,
                            "fabricStyleColorCode",
                          )
                        }
                      >
                        Color
                        {this.props.order === "desc" &&
                        this.props.sortField === "fabricStyleColorCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLocationChange(e, "onHandQuantity")
                        }
                      >
                        OnHandQty
                        {this.props.order === "desc" &&
                        this.props.sortField === "onHandQuantity" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </thead>
                    {this.props.invDatas != null && (
                      <tbody>
                        {this.props.invDatas.map(
                          (line, i) =>
                            line.onHandQuantity != 0 && (
                              <tr key={i}>
                                <td>{line.locationCode}</td>
                                <td>{line.fabricStyleColorCode}</td>
                                <td>{line.onHandQuantity}</td>
                              </tr>
                            ),
                        )}
                      </tbody>
                    )}
                  </Table>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>Line#</FormLabel>{" "}
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="lineNumber"
                      type="text"
                      onChange={this.rollSkuOnChange}
                      readOnly={true}
                      value={inventoryAdjustmentLineData.lineNumber}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>
                      {this.props.is3PL ? "Inventory#" : "RollSKU"}
                    </FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      ref={this.rollSkuRef}
                      name="rollSkuNumber"
                      // type="Number"
                      placeholder={
                        this.props.is3PL ? "Enter Inventory#" : "Enter rollSKU#"
                      }
                      value={inventoryAdjustmentLineData.rollSkuNumber}
                      onChange={this.rollSkuNumberOnChange}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />
                    {/* <NumberFormatInputbox
                      ref={this.rollSkuRef}
                      name={"rollSkuNumber"}
                      placeholder="Enter rollSkuNumber"
                      value={inventoryAdjustmentLineData.rollSkuNumber}
                      onChange={this.rollSkuNumberOnChange}
                      className="text-right"
                      disabled={isDisabledFields}
                    /> */}
                  </Col>
                  <Col className="align-fabricStyles-left" sm="1">
                    {this.props.is3PL ? (
                      <FormLabel>Item</FormLabel>
                    ) : (
                      <FormLabel>FabricStyle</FormLabel>
                    )}
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="fabricStyleCode"
                      type="text"
                      onChange={this.rollSkuOnChange}
                      readOnly={true}
                      value={inventoryAdjustmentLineData.fabricStyleCode}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      name="fabricStyleShortName"
                      type="text"
                      value={inventoryAdjustmentLineData.fabricStyleShortName}
                      onChange={this.rollSkuOnChange}
                      readOnly={true}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Color</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="fabricStyleColorCode"
                      type="text"
                      value={inventoryAdjustmentLineData.fabricStyleColorCode}
                      onChange={this.rollSkuOnChange}
                      readOnly={true}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Width</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="widthCode"
                      type="text"
                      placeholder="Enter widthCode"
                      value={inventoryAdjustmentLineData.widthCode}
                      onChange={this.rollSkuOnChange}
                      readOnly={true}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>UOM</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="uomCode"
                      type="text"
                      placeholder="Enter uomCode"
                      value={inventoryAdjustmentLineData.uomCode}
                      onChange={this.rollSkuOnChange}
                      readOnly={true}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>OnHandQty</FormLabel>
                  </Col>
                  <Col sm="2">
                    <NumberFormatInputbox
                      name={"onHandQuantity"}
                      onChange={this.rollSkuOnChange}
                      placeholder="Enter orderQuantity"
                      value={inventoryAdjustmentLineData.onHandQuantity}
                      className="text-right"
                      decimalScale={2}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>AdjustQty</FormLabel>
                  </Col>
                  <Col sm="2">
                    <NumberFormatInputbox
                      name={"quantity"}
                      onChange={this.rollSkuOnChange}
                      placeholder="Enter orderQuantity"
                      value={inventoryAdjustmentLineData.quantity}
                      className="text-right"
                      decimalScale={2}
                      // readOnly={isDisabledFields}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Location</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="locationCode"
                      type="text"
                      placeholder="Enter locationCode"
                      value={inventoryAdjustmentLineData.locationCode}
                      onChange={this.rollSkuOnChange}
                      readOnly={true}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Bin Loc</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="binLocation"
                      type="text"
                      placeholder="Enter binLocation"
                      value={inventoryAdjustmentLineData.binLocation}
                      onChange={this.rollSkuOnChange}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>{this.props.is3PL ? "Seq#" : "Roll#"}</FormLabel>
                  </Col>
                  <Col sm="2">
                    <NumberFormatInputbox
                      name={"rollNumber"}
                      onChange={this.rollSkuOnChange}
                      placeholder={
                        this.props.is3PL ? "Enter Seq" : "Enter Roll"
                      }
                      value={inventoryAdjustmentLineData.rollNumber}
                      className="text-right"
                      decimalScale={0}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>
                      {this.props.is3PL ? "SkuQty" : "RollSku OnHandQty"}
                    </FormLabel>
                  </Col>
                  <Col sm="2">
                    <NumberFormatInputbox
                      name={"rollSkuOnHandQuantity"}
                      onChange={this.rollSkuOnChange}
                      placeholder="Enter cost"
                      value={inventoryAdjustmentLineData.rollSkuOnHandQuantity}
                      className="text-right"
                      decimalScale={2}
                      disabled={true}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>VENDOR LOT</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="vendorBatchNumber"
                      type="text"
                      placeholder="Enter VENDOR LOT"
                      value={inventoryAdjustmentLineData.vendorBatchNumber}
                      onChange={this.rollSkuOnChange}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />
                  </Col>
                  {!is3PL ? (
                    <>
                      <Col sm="1">
                        <FormLabel>Box</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="boxNumber"
                          type="text"
                          placeholder="Enter boxNumber"
                          value={inventoryAdjustmentLineData.boxNumber}
                          onChange={this.rollSkuOnChange}
                          disabled={isDisabledFields}
                        />
                      </Col>
                    </>
                  ) : null}
                </Row>
                {this.props.isshowaddorupdatebutton ? (
                  <div>
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      onClick={(e) => this.addUpdateRollLine(e)}
                    >
                      Add/Update
                    </Button>
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      onClick={(e) => this.clearRollLineValues(e)}
                    >
                      Clear
                    </Button>
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </div>
        <div>
          <MultiViewPopup
            isModulePopup={false}
            isShowPopup={this.props.isShowBinPopup}
            closeOnEsc={false}
            popupLvlClass={"popupSizeLevel1"}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Add Rolls From Bin Inventory Location"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.props.alertMessage}
                alertErrorType={this.props.alertType}
                isShowAlert={this.props.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.binAddLine(e)}
                >
                  Add line
                </Button>
              </div>
            }
            content={
              <div>
                <div className="header_div">
                  <Row>
                    <Col sm="1">
                      <FormLabel>BinLocation</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onChange={this.binLocationCodeOnChange}
                        name="binLocationStartsWith"
                        placeholder="binLocationStartsWith"
                        value={rollCriteria.binLocationStartsWith}
                        // lookupRequired={true}
                        // lookupHandler={this.props.binLookupHandler}
                        // enterKeyEventHandler={
                        //   this.binLocationEnterKeyEventHandler
                        // }
                        // autoCompleteListData={
                        //   this.props.binLocationPageListForAutoCompleteList
                        // }
                        // enableAutoCompleteTextBox={true}
                        // displayAutoCompleteList={
                        //   this.displayAutoCompleteBinLocationList
                        // }
                        // showAutoCompleteList={
                        //   this.props.showAutoCompleteBinLocationList
                        // }
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Location </FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="locationCode"
                        placeholder="Enter locationCode"
                        onChange={this.onLocationCodeChange}
                        value={rollCriteria.locationCode}
                        lookupRequired={true}
                        lookupHandler={this.state.warehouseLookupHandler}
                        enterKeyEventHandler={
                          this.locationCodeEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.props.locationPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteLocationList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteLocationList
                        }
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      <Button
                        id="fabric_Add_Button"
                        className="enterFocus"
                        size="sm1"
                        onClick={(e) => this.fetchRolls(e)}
                      >
                        FetchRolls
                      </Button>
                    </Col>
                    <Col sm="1">
                      <Button
                        id="fabric_Add_Button"
                        className="enterFocus"
                        size="sm1"
                        onClick={(e) => this.binSelectAll(e)}
                      >
                        SelectAll
                      </Button>
                    </Col>
                    <Col sm="1">
                      <Button
                        id="fabric_Add_Button"
                        className="enterFocus"
                        size="sm1"
                        onClick={(e) => this.binUnSelectAll(e)}
                      >
                        UnSelectAll
                      </Button>
                    </Col>
                    <Col sm="1">
                      <Button
                        id="fabric_Add_Button"
                        className="enterFocus"
                        size="sm1"
                        onClick={(e) => this.binMakeZero(e)}
                      >
                        MakeZero
                      </Button>
                    </Col>
                    <Col sm="2">
                      <Button
                        id="fabric_Add_Button"
                        className="enterFocus"
                        size="sm1"
                        onClick={(e) => this.binLocClear(e)}
                      >
                        BinLocClear
                      </Button>
                    </Col>
                  </Row>
                  <div className="div_default">
                    {/* <EditableDataGrid
                      customStyles={newLinestyles}
                      columnsList={this.binLineColumnDefinitions()}
                      dataList={binInventoryList}
                    /> */}
                    <CustomTable
                      columns={this.binLineColumns()}
                      data={binInventoryList}
                      label={"Bin Inventory List"}
                      enableVritualizer={true}
                    />
                  </div>
                </div>
              </div>
            }
          />
        </div>
        <div>
          <MultiViewPopup
            isModulePopup={false}
            isShowPopup={this.props.isShowFabricPopup}
            closeOnEsc={false}
            popupLvlClass={"popupSizeLevel1"}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={
              this.props.is3PL
                ? "Add Rolls From Item"
                : "Add Rolls From FabricStyle"
            }
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.props.alertMessage}
                alertErrorType={this.props.alertType}
                isShowAlert={this.props.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.fabricRollAddLine(e)}
                >
                  Add line
                </Button>
              </div>
            }
            content={
              <div>
                <div className="header_div">
                  <Row>
                    <Col className="align-fabricStyles-left" sm="1">
                      {this.props.is3PL ? (
                        <FormLabel>Item</FormLabel>
                      ) : (
                        <FormLabel>FabricStyle</FormLabel>
                      )}
                    </Col>

                    <Col sm="2">
                      <InputTextbox
                        onChange={this.fabricRollCriteriaOnChange}
                        ref={this.fabricStyleCodeRef}
                        name="fabricStyleCode"
                        placeholder={this.props.is3PL ? "Item" : "FabricStyle"}
                        value={fabricRollCriteria.fabricStyleCode}
                        lookupRequired={true}
                        lookupHandler={this.state.fabricLookupHandler}
                        enterKeyEventHandler={
                          this.fabricRollEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.props.fabricPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteFabricList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteFabricList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="fabricStyleShortName"
                        type="text"
                        value={fabricRollCriteria.fabricStyleShortName}
                        readOnly={true}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Color</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        ref={this.fabricStyleColorCodeRef}
                        name="colorCode"
                        placeholder="Enter Color"
                        onChange={this.fabricRollColorOnChange}
                        readOnly={false}
                        value={fabricRollCriteria.colorCode}
                        lookupRequired={this.props.isShowColorLookup}
                        lookupHandler={this.props.colorLookupHandler}
                        enterKeyEventHandler={
                          this.fabricRollColorEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.props.fabricColourPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteFabricColorList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompleteFabricColorList
                        }
                        valuePropery="fabricStyleColorCode"
                        disabled={!this.props.isShowColorLookup}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      <Button
                        id="fabric_Add_Button"
                        className="enterFocus"
                        size="sm1"
                        onClick={(e) => this.fabricFetchRolls(e)}
                      >
                        FetchRolls
                      </Button>
                    </Col>
                    <Col sm="1">
                      <Button
                        id="fabric_Add_Button"
                        className="enterFocus"
                        size="sm1"
                        onClick={(e) => this.makeZero(e)}
                      >
                        MakeZero
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <Button
                        id="fabric_Add_Button"
                        className="enterFocus"
                        size="sm1"
                        onClick={(e) => this.fabricSelectAll(e)}
                      >
                        SelectAll
                      </Button>
                    </Col>
                    <Col sm="2">
                      <Button
                        id="fabric_Add_Button"
                        className="enterFocus"
                        size="sm1"
                        onClick={(e) => this.fabricUnSelectAll(e)}
                      >
                        UnSelectAll
                      </Button>
                    </Col>
                  </Row>
                  <div className="div_Custom_10">
                    {fabricStyleRollList != null && (
                      // <EditableDataGrid
                      //   customStyles={newLinestyles}
                      //   columnsList={this.fabricLineColumnDefinitions()}
                      //   dataList={fabricStyleRollList}
                      // />
                      <CustomTable
                        columns={this.fabricLineColumns()}
                        data={fabricStyleRollList}
                        label={"Fabric Roll List"}
                        // cstmStyle="div_Custom_2 "
                        enableVritualizer={true}
                      />
                    )}
                  </div>
                </div>
              </div>
            }
          />
        </div>
        <div>
          <MultiViewPopup
            isModulePopup={false}
            isShowPopup={this.props.isShowReceiptPopup}
            closeOnEsc={false}
            popupLvlClass={"popupSizeLevel6"}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Load From PurchaseReceipt"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.props.alertMessage}
                alertErrorType={this.props.alertType}
                isShowAlert={this.props.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            content={
              // <div className="header_div">
              <div>
                <div>
                  {" "}
                  <Row className="d-flex justify-content-center">
                    <Col sm="1">
                      <FormLabel>Receipt#</FormLabel>{" "}
                    </Col>

                    <Col sm="4">
                      {/* <InputTextbox
                        onChange={this.receiptOnChange}
                        ref={this.receiptCodeRef}
                        name="purchaseOrderReceiptNumber"
                        placeholder="purchaseOrderReceiptNumber"
                        value={receiptCriteria.purchaseOrderReceiptNumber}
                        lookupRequired={true}
                        lookupHandler={this.state.purchaseReceiptLookupHandler}
                        showCriteriaDialog={true}
                        disabled={isDisabledFields}
                      ></InputTextbox> */}
                      <InputTextbox
                        onChange={this.onPurchaseReceiptChange}
                        ref={this.receiptCodeRef}
                        name="purchaseOrderReceiptNumber"
                        placeholder="purchaseOrderReceiptNumber"
                        value={receiptCriteria.purchaseOrderReceiptNumber}
                        lookupRequired={true}
                        lookupHandler={this.state.purchaseReceiptLookupHandler}
                        showCriteriaDialog={true}
                        enterKeyEventHandler={
                          this.purchaseReceiptEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.props.purchaseReceiptPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompletepurchaseReceiptList
                        }
                        showAutoCompleteList={
                          this.props.showAutoCompletepurchaseReceiptList
                        }
                        disabled={isDisabledFields}
                        isMandatory={true}
                      ></InputTextbox>
                    </Col>
                  </Row>
                  <Row className="d-flex justify-content-center">
                    <Col sm="2">
                      <Button
                        id="fabric_Add_Button"
                        className="enterFocus"
                        size="sm1"
                        onClick={(e) => this.loadReceiptRolls(e)}
                      >
                        Go
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            }
          />
        </div>
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.props.isShowOnHandQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"OnHandQuantity"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <OnHandQtyPopUp
              inventoryAdjustmentNewLineData={
                this.props.inventoryAdjustmentNewLineData
              }
              inventoryData={this.props.inventoryData}
              onHandQtyData={this.props.onHandQtyData}
              handleSortingOnHandChange={this.props.handleSortingOnHandChange}
              is3PL={this.props.is3PL}
              order={this.props.order}
              sortField={this.props.sortField}
            />
          }
        />
      </div>
    );
  }
}
class OnHandQtyPopUp extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  handleSortingOnHandChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingOnHandChange(accessor);
  };

  render() {
    let inventoryAdjustmentNewLineData =
      this.props.inventoryAdjustmentNewLineData;
    let onHandQty = this.props.onHandQtyData;
    return (
      <div className="header_div">
        <Row>
          <Col sm="1">
            <FormLabel>CompanyCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={inventoryAdjustmentNewLineData.companyCode}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Adjustment</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={inventoryAdjustmentNewLineData.adjustmentCode}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Line</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={inventoryAdjustmentNewLineData.lineNumber}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Location</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={inventoryAdjustmentNewLineData.locationCode}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              value={inventoryAdjustmentNewLineData.fabricStyleCode}
              disabled={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              value={inventoryAdjustmentNewLineData.fabricStyleShortName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={inventoryAdjustmentNewLineData.fabricStyleColorCode}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Width</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={inventoryAdjustmentNewLineData.widthCode}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>AdjustQty</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              className="qty_input text-right summary_input"
              value={inventoryAdjustmentNewLineData.quantity}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>OnHand Qty</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              className="qty_input text-right summary_input"
              value={inventoryAdjustmentNewLineData.onHandQuantity}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>UOM</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={inventoryAdjustmentNewLineData.uomCode}
              disabled={true}
            />
          </Col>
        </Row>
        <div className="div_default">
          <Table id="fabrics_tables">
            <thead>
              <tr>
                <th
                  onClick={(e) =>
                    this.handleSortingOnHandChange(e, "locationCode")
                  }
                >
                  Location
                  {this.props.order === "desc" &&
                  this.props.sortField === "locationCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingOnHandChange(e, "boxNumber")
                  }
                >
                  Box#
                  {this.props.order === "desc" &&
                  this.props.sortField === "boxNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingOnHandChange(e, "rollSkuNumber")
                  }
                >
                  {this.props.is3PL ? "Inventory#" : "RollSKU#"}
                  {this.props.order === "desc" &&
                  this.props.sortField === "rollSkuNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingOnHandChange(e, "vendorBatchNumber")
                  }
                >
                  VENDOR LOT#
                  {this.props.order === "desc" &&
                  this.props.sortField === "vendorBatchNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingOnHandChange(e, "rollNumber")
                  }
                >
                  {this.props.is3PL ? "Seq#" : "Roll#"}
                  {this.props.order === "desc" &&
                  this.props.sortField === "rollNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingOnHandChange(e, "onHandQuantity")
                  }
                >
                  OnHandQty
                  {this.props.order === "desc" &&
                  this.props.sortField === "onHandQuantity" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {onHandQty != null && (
              <tbody>
                {onHandQty.map((ln, index) => (
                  <tr key={index}>
                    <td>{ln.locationCode}</td>
                    <td>{ln.boxNumber}</td>
                    <td className="text-right">{ln.rollSkuNumber}</td>
                    <td>{ln.vendorBatchNumber}</td>
                    <td>{ln.rollNumber}</td>
                    <td className="text-right">{ln.onHandQuantity}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </Table>
        </div>
      </div>
    );
  }
}
function InventoryAdjustmentModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <InventoryAdjustmentList {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default InventoryAdjustmentModule;
